import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotificationBonuses = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={185}
      height={185}
      viewBox="0 0 185 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M92.5 182.869c46.482 0 84.164-21.756 84.164-48.592 0-26.837-37.682-48.592-84.164-48.592-46.483 0-84.164 21.755-84.164 48.592 0 26.836 37.681 48.592 84.164 48.592Z"
        fill="#F5F5F5"
        fillOpacity={0.2}
      />
      <path
        d="M28.046 164.225c7.595 0 13.753-3.555 13.753-7.941 0-4.385-6.158-7.94-13.753-7.94-7.596 0-13.753 3.555-13.753 7.94 0 4.386 6.157 7.941 13.753 7.941Z"
        fill="#959595"
      />
      <path
        d="M43.187 171.676c7.595 0 13.752-3.555 13.752-7.94s-6.157-7.94-13.752-7.94c-7.596 0-13.753 3.555-13.753 7.94s6.157 7.94 13.753 7.94Z"
        fill="#959595"
      />
      <path
        d="m53.535 165.793-6.586-3.8c-17.22-9.942-17.22-26.062 0-36.004l29.57-17.072c17.22-9.942 45.14-9.942 62.36 0l6.586 3.8c17.22 9.942 17.22 26.063 0 36.004l-29.566 17.072c-17.224 9.957-45.144 9.957-62.364 0Z"
        fill="#959595"
      />
      <path
        d="M157.868 156.162c6.688 0 12.11-3.131 12.11-6.993 0-3.862-5.422-6.993-12.11-6.993s-12.11 3.131-12.11 6.993c0 3.862 5.422 6.993 12.11 6.993Zm-19.373 13.028c6.688 0 12.11-3.131 12.11-6.993 0-3.862-5.422-6.993-12.11-6.993s-12.11 3.131-12.11 6.993c0 3.862 5.422 6.993 12.11 6.993Z"
        fill="#959595"
      />
      <path
        d="M12.436 111.607a.152.152 0 0 1-.1-.038.15.15 0 0 1-.048-.096l-.37-4.047a.74.74 0 0 0-.636-.652l-3.175-.347a.152.152 0 0 1-.13-.148c0-.036.014-.071.037-.098a.149.149 0 0 1 .093-.047l3.175-.37a.74.74 0 0 0 .636-.647l.37-4.048a.148.148 0 0 1 .146-.125c.035 0 .07.013.096.036a.147.147 0 0 1 .05.089l.37 4.048a.717.717 0 0 0 .637.647l3.17.37a.149.149 0 0 1 .093.047.146.146 0 0 1 0 .195.152.152 0 0 1-.092.051l-3.171.347a.72.72 0 0 0-.637.652l-.37 4.047a.148.148 0 0 1-.144.134Zm-2.96-5.328 1.85.207a1.017 1.017 0 0 1 .884.914l.219 2.431.218-2.431a1.013 1.013 0 0 1 .895-.914l1.85-.207-1.85-.204a1.01 1.01 0 0 1-.895-.914l-.218-2.434-.219 2.434a1.015 1.015 0 0 1-.895.914l-1.839.204Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M16.883 120.094a.147.147 0 0 1-.144-.133l-.248-2.756a.441.441 0 0 0-.392-.4l-2.16-.255a.145.145 0 0 1-.103-.247.144.144 0 0 1 .102-.042l2.161-.24a.447.447 0 0 0 .392-.4l.248-2.757a.147.147 0 0 1 .146-.124.147.147 0 0 1 .146.124l.248 2.757a.44.44 0 0 0 .393.4l2.157.24a.144.144 0 1 1 0 .289l-2.157.24a.436.436 0 0 0-.393.4l-.259 2.771a.147.147 0 0 1-.137.133Zm-1.598-3.674.847.093a.737.737 0 0 1 .651.666l.1 1.139.104-1.139a.737.737 0 0 1 .651-.666l.847-.093-.847-.092a.744.744 0 0 1-.651-.666l-.104-1.14-.1 1.14a.74.74 0 0 1-.65.666l-.848.092Z"
        fill="#FFD04E"
      />
      <path
        d="M20.946 75.373a.1.1 0 0 1-.103-.093l-.263-2.89a.507.507 0 0 0-.451-.462l-2.265-.252a.107.107 0 0 1-.092-.103.1.1 0 0 1 .092-.104l2.264-.252a.51.51 0 0 0 .452-.462l.263-2.89a.104.104 0 0 1 .103-.096.107.107 0 0 1 .104.096l.259 2.89a.514.514 0 0 0 .455.462l2.264.252a.104.104 0 0 1 .066.172.107.107 0 0 1-.066.035l-2.264.252a.514.514 0 0 0-.455.462l-.26 2.89a.104.104 0 0 1-.103.093Zm-2.12-3.8 1.325.144a.74.74 0 0 1 .64.655l.155 1.735.144-1.735a.74.74 0 0 1 .64-.655l1.325-.144-1.324-.148a.74.74 0 0 1-.64-.652l-.156-1.735-.155 1.735a.74.74 0 0 1-.63.637l-1.324.163Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M17.02 79.728a.085.085 0 0 1-.085-.078l-.144-1.606a.255.255 0 0 0-.23-.233l-1.261-.14a.085.085 0 0 1-.053-.142.088.088 0 0 1 .053-.029l1.261-.137a.263.263 0 0 0 .23-.233l.144-1.61a.085.085 0 0 1 .085-.077.085.085 0 0 1 .085.078l.145 1.61a.263.263 0 0 0 .229.232l1.258.137a.089.089 0 0 1 .078.085.085.085 0 0 1-.078.085l-1.258.14a.255.255 0 0 0-.23.234l-.144 1.606a.085.085 0 0 1-.085.078Zm-.932-2.143.492.056a.429.429 0 0 1 .37.37l.059.662.06-.662a.429.429 0 0 1 .37-.37l.491-.056-.492-.055a.43.43 0 0 1-.37-.37l-.048-.681-.06.666a.43.43 0 0 1-.37.37l-.502.07Z"
        fill="#fff"
      />
      <path
        d="M160.71 116.136a.119.119 0 0 1-.078-.03.117.117 0 0 1-.037-.074l-.285-3.175a.56.56 0 0 0-.499-.507l-2.487-.277a.108.108 0 0 1-.073-.035.113.113 0 0 1-.001-.153.114.114 0 0 1 .074-.038l2.487-.274a.56.56 0 0 0 .499-.51l.285-3.171a.117.117 0 0 1 .037-.075.114.114 0 0 1 .078-.032c.029 0 .056.012.078.032a.117.117 0 0 1 .037.075l.284 3.171a.56.56 0 0 0 .5.51l2.486.274a.117.117 0 0 1 .072.039.117.117 0 0 1 0 .151.116.116 0 0 1-.072.036l-2.486.277a.565.565 0 0 0-.5.507l-.284 3.175a.116.116 0 0 1-.115.104Zm-2.331-4.174 1.461.148a.79.79 0 0 1 .7.718l.174 1.905.17-1.905a.788.788 0 0 1 .224-.484.79.79 0 0 1 .479-.234l1.454-.159-1.454-.163a.788.788 0 0 1-.703-.714l-.17-1.909-.174 1.909a.789.789 0 0 1-.7.714l-1.461.174Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M169.345 110.7a.092.092 0 0 1-.063-.024.095.095 0 0 1-.029-.061l-.159-1.765a.287.287 0 0 0-.082-.171.287.287 0 0 0-.17-.084l-1.384-.155a.096.096 0 0 1-.061-.03.097.097 0 0 1-.024-.063.094.094 0 0 1 .085-.092l1.384-.152a.287.287 0 0 0 .17-.084.287.287 0 0 0 .082-.171l.159-1.765a.08.08 0 0 1 .008-.034.095.095 0 0 1 .02-.028.092.092 0 0 1 .03-.018.078.078 0 0 1 .034-.005.078.078 0 0 1 .034.005.092.092 0 0 1 .051.046.13.13 0 0 1 .008.034l.159 1.765a.287.287 0 0 0 .08.172.288.288 0 0 0 .171.083l1.384.152a.091.091 0 0 1 .082.092.09.09 0 0 1-.022.063.094.094 0 0 1-.06.03l-1.384.155a.288.288 0 0 0-.171.083.287.287 0 0 0-.08.172l-.159 1.765a.092.092 0 0 1-.093.085Zm-1.025-2.353.54.059a.478.478 0 0 1 .419.426l.066.74.067-.74a.473.473 0 0 1 .418-.422l.544-.059-.544-.059a.475.475 0 0 1-.415-.426l-.066-.74-.067.74a.471.471 0 0 1-.418.426l-.544.055Zm-4.096-4.903a.143.143 0 0 1-.101-.039.15.15 0 0 1-.047-.097l-.255-2.831a.455.455 0 0 0-.403-.411l-2.22-.248a.147.147 0 0 1-.148-.148.147.147 0 0 1 .148-.148l2.22-.247a.458.458 0 0 0 .403-.411l.255-2.83a.151.151 0 0 1 .047-.098.152.152 0 0 1 .253.098l.255 2.83a.455.455 0 0 0 .404.41l2.22.248c.039 0 .077.016.104.044a.147.147 0 0 1 0 .21.145.145 0 0 1-.104.042l-2.22.248a.455.455 0 0 0-.404.411l-.255 2.831a.152.152 0 0 1-.152.136Zm-1.642-3.773.869.096a.759.759 0 0 1 .67.68l.103 1.173.108-1.169a.734.734 0 0 1 .669-.684l.87-.096-.87-.097a.74.74 0 0 1-.669-.68l-.108-1.17-.103 1.17a.759.759 0 0 1-.67.684l-.869.093Z"
        fill="#fff"
      />
      <path
        d="M162.531 78.736a.136.136 0 0 1-.133-.122l-.337-3.719a.663.663 0 0 0-.585-.6l-2.912-.321a.134.134 0 0 1-.122-.133.138.138 0 0 1 .122-.133l2.912-.323a.655.655 0 0 0 .585-.595l.337-3.7a.133.133 0 1 1 .266 0l.337 3.7a.655.655 0 0 0 .584.596l2.916.321a.14.14 0 0 1 .084.045.132.132 0 0 1 .034.089.133.133 0 0 1-.118.133l-2.916.322a.657.657 0 0 0-.584.599l-.337 3.719a.137.137 0 0 1-.133.122ZM159.8 73.84l1.706.188a.936.936 0 0 1 .825.84l.2 2.22.203-2.22a.93.93 0 0 1 .822-.84l1.705-.188-1.705-.19a.922.922 0 0 1-.822-.84l-.203-2.22-.2 2.22a.934.934 0 0 1-.825.84l-1.706.19Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M157.251 69.397a.11.11 0 0 1-.075-.028.105.105 0 0 1-.036-.072l-.185-2.068a.337.337 0 0 0-.296-.3l-1.628-.181a.109.109 0 0 1-.1-.107.11.11 0 0 1 .029-.074.113.113 0 0 1 .071-.037l1.62-.178a.339.339 0 0 0 .296-.3l.185-2.068a.115.115 0 0 1 .035-.074.112.112 0 0 1 .076-.03.11.11 0 0 1 .075.03c.02.02.031.046.032.074l.185 2.068a.337.337 0 0 0 .296.3l1.621.178a.118.118 0 0 1 .071.037c.018.02.028.046.029.074a.11.11 0 0 1-.03.072.11.11 0 0 1-.07.035l-1.621.181a.333.333 0 0 0-.296.3l-.185 2.068a.107.107 0 0 1-.099.1Zm-1.203-2.756.636.07a.553.553 0 0 1 .489.496l.078.873.074-.858a.55.55 0 0 1 .488-.496l.636-.07-.636-.07a.56.56 0 0 1-.488-.5l-.074-.855-.078.855a.561.561 0 0 1-.489.5l-.636.055Z"
        fill="#fff"
      />
      <path
        d="M31.147 33.126a.13.13 0 0 1-.13-.115l-.307-3.585a.632.632 0 0 0-.577-.566l-2.808-.31a.13.13 0 1 1 0-.26l2.808-.31a.636.636 0 0 0 .577-.582l.322-3.585a.134.134 0 0 1 .13-.118.13.13 0 0 1 .13.118l.321 3.585a.64.64 0 0 0 .566.574l2.808.31a.13.13 0 0 1 0 .26l-2.823.318a.64.64 0 0 0-.566.573l-.322 3.586a.126.126 0 0 1-.13.107Zm-2.63-4.714 1.646.182a.9.9 0 0 1 .791.81l.193 2.153.196-2.153a.895.895 0 0 1 .792-.81l1.646-.182-1.646-.181a.9.9 0 0 1-.792-.81l-.196-2.154-.192 2.154a.903.903 0 0 1-.792.81l-1.647.181Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M27.21 42.72a.108.108 0 0 1-.107-.096l-.178-1.968a.315.315 0 0 0-.277-.289l-1.543-.17a.104.104 0 0 1-.096-.104.107.107 0 0 1 .096-.103l1.543-.17a.311.311 0 0 0 .277-.285l.178-1.972a.108.108 0 0 1 .21 0l.178 1.972a.31.31 0 0 0 .278.285l1.547.17a.107.107 0 0 1 .092.103.104.104 0 0 1-.092.104l-1.547.17a.314.314 0 0 0-.277.289l-.178 1.968a.108.108 0 0 1-.104.096Zm-1.143-2.627.603.067a.532.532 0 0 1 .466.474l.074.817.07-.817a.533.533 0 0 1 .47-.474l.604-.067-.604-.066a.526.526 0 0 1-.466-.474l-.07-.817-.074.817a.526.526 0 0 1-.466.474l-.607.066Zm13.975-5.373a.14.14 0 0 1-.137-.125l-.233-2.59a.414.414 0 0 0-.37-.37l-2.02-.222a.137.137 0 0 1-.085-.227.14.14 0 0 1 .084-.047l2.02-.222a.41.41 0 0 0 .37-.37l.234-2.59a.137.137 0 1 1 .274 0l.233 2.59a.41.41 0 0 0 .37.37l2.02.222a.144.144 0 0 1 .122.137.14.14 0 0 1-.122.137l-2.02.222a.414.414 0 0 0-.37.37l-.233 2.59a.14.14 0 0 1-.137.126Zm-1.48-3.436.791.088a.689.689 0 0 1 .607.622l.096 1.066.097-1.066a.688.688 0 0 1 .61-.622l.788-.088-.788-.086a.692.692 0 0 1-.61-.621l-.096-1.07-.097 1.07a.692.692 0 0 1-.607.621l-.791.085Zm68.398-13.506a.093.093 0 0 1-.063-.024.089.089 0 0 1-.029-.06l-.16-1.758a.279.279 0 0 0-.247-.255l-1.381-.141a.096.096 0 0 1-.081-.093.093.093 0 0 1 .081-.092l1.381-.155a.277.277 0 0 0 .171-.082.275.275 0 0 0 .076-.174l.16-1.757a.09.09 0 0 1 .027-.066.09.09 0 0 1 .065-.027.09.09 0 0 1 .065.027.09.09 0 0 1 .028.066l.159 1.76a.279.279 0 0 0 .251.252l1.377.156a.09.09 0 0 1 .06.03c.016.017.025.04.025.062a.096.096 0 0 1-.026.063.092.092 0 0 1-.059.03l-1.377.152a.29.29 0 0 0-.251.255l-.159 1.757a.093.093 0 0 1-.093.074Zm-1.017-2.342.536.06a.471.471 0 0 1 .418.414l.063.74.067-.74a.465.465 0 0 1 .414-.422l.54-.06-.54-.058a.473.473 0 0 1-.414-.426l-.067-.74-.063.74a.477.477 0 0 1-.418.426l-.536.066Zm7.647 6.716a.136.136 0 0 1-.14-.126l-.23-2.638a.427.427 0 0 0-.37-.37l-2.068-.23a.14.14 0 0 1-.126-.136.145.145 0 0 1 .126-.14l2.068-.23a.421.421 0 0 0 .37-.37l.237-2.638a.142.142 0 0 1 .141-.13c.035 0 .069.013.094.037a.135.135 0 0 1 .043.093l.24 2.638a.419.419 0 0 0 .37.37l2.068.229a.141.141 0 0 1 .126.14.138.138 0 0 1-.037.093.138.138 0 0 1-.089.044l-2.068.23a.422.422 0 0 0-.37.37l-.24 2.638a.132.132 0 0 1-.014.051.115.115 0 0 1-.032.042.132.132 0 0 1-.099.032Zm-1.531-3.515.81.089a.704.704 0 0 1 .621.636l.1 1.11.097-1.11a.705.705 0 0 1 .643-.636l.811-.09-.811-.088a.704.704 0 0 1-.625-.636l-.096-1.11-.1 1.11a.707.707 0 0 1-.622.636l-.828.089Z"
        fill="#fff"
      />
      <path
        d="M155.423 47.578a.097.097 0 0 1-.068-.026.099.099 0 0 1-.032-.066l-.248-2.738a.489.489 0 0 0-.429-.44l-2.146-.237a.097.097 0 0 1-.058-.035.099.099 0 0 1 0-.127.097.097 0 0 1 .058-.034l2.146-.237a.484.484 0 0 0 .429-.44l.248-2.742a.099.099 0 0 1 .033-.064.098.098 0 0 1 .132 0 .1.1 0 0 1 .031.064l.248 2.742a.49.49 0 0 0 .433.44l2.146.237a.103.103 0 0 1 .058.034.104.104 0 0 1 0 .127.103.103 0 0 1-.058.035l-2.146.237a.489.489 0 0 0-.433.44l-.248 2.738a.096.096 0 0 1-.03.066.092.092 0 0 1-.066.026Zm-2.013-3.607 1.258.14a.69.69 0 0 1 .607.619l.148 1.646.148-1.646a.685.685 0 0 1 .607-.618l1.258-.141-1.258-.137a.687.687 0 0 1-.607-.618l-.148-1.646-.148 1.646a.69.69 0 0 1-.607.618l-1.258.137Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M162.186 43.408a.127.127 0 0 1-.085-.035.128.128 0 0 1-.041-.083l-.329-3.652a.656.656 0 0 0-.574-.588l-2.863-.315a.133.133 0 0 1-.08-.045.135.135 0 0 1 0-.172.133.133 0 0 1 .08-.045l2.863-.319a.653.653 0 0 0 .574-.584l.329-3.652a.131.131 0 0 1 .22-.087c.025.022.04.054.043.087l.329 3.652a.642.642 0 0 0 .574.584l2.864.319a.131.131 0 0 1 .079.045.13.13 0 0 1 0 .172.131.131 0 0 1-.079.045l-2.864.315a.646.646 0 0 0-.574.588l-.333 3.652a.129.129 0 0 1-.044.085.131.131 0 0 1-.089.033Zm-2.682-4.81 1.676.185a.918.918 0 0 1 .81.826l.196 2.197.2-2.197a.913.913 0 0 1 .806-.826l1.677-.184-1.677-.185a.91.91 0 0 1-.806-.822l-.2-2.198-.196 2.198a.916.916 0 0 1-.81.822l-1.676.184Z"
        fill="#fff"
      />
      <path
        d="M16.616 153.317a7.533 7.533 0 0 1 2.798-2.59c4.573-2.638 11.988-2.638 16.565 0a7.57 7.57 0 0 1 2.797 2.59h.632v2.39c-.085 1.665-1.224 3.33-3.422 4.585-4.577 2.641-11.992 2.641-16.565 0-2.201-1.269-3.33-2.92-3.43-4.585v-2.39h.625Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M16.616 153.317a7.533 7.533 0 0 1 2.798-2.59c4.573-2.638 11.988-2.638 16.565 0a7.57 7.57 0 0 1 2.797 2.59h.632v2.39c-.085 1.665-1.224 3.33-3.422 4.585-4.577 2.641-11.992 2.641-16.565 0-2.201-1.269-3.33-2.92-3.43-4.585v-2.39h.625Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M27.694 148.74c2.997 0 5.994.659 8.285 1.98a7.561 7.561 0 0 1 2.797 2.59h.632v2.39c-.085 1.665-1.224 3.33-3.422 4.584-2.29 1.321-5.287 1.98-8.284 1.98l-.008-13.524Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M34.092 149.85a13.13 13.13 0 0 1 1.887.881 7.562 7.562 0 0 1 2.797 2.59h.633v2.39c-.085 1.665-1.225 3.33-3.423 4.584-.604.344-1.235.64-1.887.885l-.007-11.33Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M21.298 149.85c-.65.243-1.28.537-1.884.881a7.531 7.531 0 0 0-2.797 2.59h-.633v2.39c.082 1.665 1.229 3.33 3.43 4.584.603.345 1.233.641 1.884.885v-11.33Z"
        fill="#FFD04E"
      />
      <path
        d="M35.979 148.537c4.573 2.638 4.573 6.923 0 9.561-4.004 2.312-10.183 2.59-14.73.869l-.181-.07c-.57-.224-1.123-.49-1.654-.796-3.815-2.22-4.44-5.55-1.902-8.14a8.884 8.884 0 0 1 1.898-1.431c4.577-2.635 11.992-2.635 16.569.007Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M35.979 148.537c4.573 2.638 4.573 6.923 0 9.561-4.004 2.312-10.183 2.59-14.73.869l-.181-.07c-.57-.224-1.123-.49-1.654-.796-3.815-2.22-4.44-5.55-1.902-8.14a8.884 8.884 0 0 1 1.898-1.431c4.577-2.635 11.992-2.635 16.569.007Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M17.512 149.972a5.117 5.117 0 0 0-1.232 4.17c.407 2.327 3.659 4.281 4.78 4.751-.57-.224-1.123-.49-1.654-.796-3.807-2.201-4.44-5.542-1.894-8.125Zm20.365 6.69a5.122 5.122 0 0 0 1.225-4.174c-.404-2.323-3.66-4.277-4.78-4.747.57.225 1.124.491 1.657.796 3.81 2.201 4.447 5.542 1.898 8.125Z"
        fill="#F5F5F5"
      />
      <path
        d="M27.699 159.592c6.014 0 10.889-2.814 10.889-6.286 0-3.472-4.875-6.286-10.89-6.286-6.013 0-10.888 2.814-10.888 6.286 0 3.472 4.875 6.286 10.889 6.286Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M27.699 159.592c6.014 0 10.889-2.814 10.889-6.286 0-3.472-4.875-6.286-10.89-6.286-6.013 0-10.888 2.814-10.888 6.286 0 3.472 4.875 6.286 10.889 6.286Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M17.305 155.186c-.873-1.617-.588-3.401.855-4.914a7.17 7.17 0 0 1 .925-.807 8.4 8.4 0 0 1 .895-.58c.174-.104.352-.2.537-.293-.451.74-.289 1.543 2.275 1.691 5.021.292-1.339 5.091-1.339 5.091s-3.249-1.561-4.148-.188Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M17.823 153.857c-.74-.085-1.11-.858-.832-1.728.277-.869 1.14-1.509 1.88-1.424.74.085 1.11.858.832 1.728-.278.869-1.125 1.509-1.88 1.424Z"
        fill="#fff"
      />
      <path
        d="M25.764 157.853c.244-1.85 8.391-7.03 8.391-7.03s1.806-.721 1.206-1.987c.301.174.593.363.874.567.185.133.37.273.529.418 2.423 2.098 2.427 4.858 0 6.959a6.576 6.576 0 0 1-.526.418c-.26.191-.53.367-.81.526a10.243 10.243 0 0 1-1.602.769c-.255.097-.503.193-.766.278-.794.257-1.607.451-2.43.581l-.545.081a18.577 18.577 0 0 1-5.39-.092s1.302-.241 1.069-1.488Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M25.764 157.853c.244-1.85 8.391-7.03 8.391-7.03s1.806-.721 1.206-1.987c.301.174.593.363.874.567.185.133.37.273.529.418 2.423 2.098 2.427 4.858 0 6.959a6.576 6.576 0 0 1-.526.418c-.26.191-.53.367-.81.526a10.243 10.243 0 0 1-1.602.769c-.255.097-.503.193-.766.278-.794.257-1.607.451-2.43.581l-.545.081a18.577 18.577 0 0 1-5.39-.092s1.302-.241 1.069-1.488Z"
        fill="#fff"
      />
      <path
        d="M33.441 149.995c3.038 1.757 3.16 4.555.37 6.393a8.663 8.663 0 0 1-.37.23c-3.167 1.831-8.303 1.831-11.47 0-3.167-1.832-3.167-4.81 0-6.623.13-.074.263-.144.4-.215 3.182-1.609 8.029-1.539 11.07.215Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M33.441 149.995c3.038 1.757 3.16 4.555.37 6.393a8.663 8.663 0 0 1-.37.23c-3.167 1.831-8.303 1.831-11.47 0-3.167-1.832-3.167-4.81 0-6.623.13-.074.263-.144.4-.215 3.182-1.609 8.029-1.539 11.07.215Z"
        fill="#000"
      />
      <path
        d="M27.699 157.783c4.283 0 7.755-2.004 7.755-4.477 0-2.472-3.472-4.477-7.755-4.477-4.284 0-7.756 2.005-7.756 4.477 0 2.473 3.473 4.477 7.756 4.477Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M27.699 157.783c4.283 0 7.755-2.004 7.755-4.477 0-2.472-3.472-4.477-7.755-4.477-4.284 0-7.756 2.005-7.756 4.477 0 2.473 3.473 4.477 7.756 4.477Z"
        fill="#000"
      />
      <path
        d="M33.181 151.389c-3.026-1.746-7.936-1.746-10.966 0-1.236.714-1.969 1.614-2.195 2.542.226.929.959 1.828 2.195 2.542 3.03 1.747 7.94 1.747 10.966 0 1.229-.703 1.969-1.613 2.195-2.553-.226-.917-.966-1.817-2.195-2.531Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M33.181 151.389c-3.026-1.746-7.936-1.746-10.966 0-1.236.714-1.969 1.614-2.195 2.542.226.929.959 1.828 2.195 2.542 3.03 1.747 7.94 1.747 10.966 0 1.229-.703 1.969-1.613 2.195-2.553-.226-.917-.966-1.817-2.195-2.531Z"
        fill="#000"
      />
      <path
        d="M32.582 154.66v-.925c0-.37-.263-.74-.829-1.08a3.962 3.962 0 0 0-3.074-.281 10.62 10.62 0 0 0-1.147.37 11.73 11.73 0 0 1-1.232.37 2.21 2.21 0 0 1-.585.055 1.24 1.24 0 0 1-.485-.129l.037-.026.122-.074c.105-.061.214-.115.326-.163a2.248 2.248 0 0 1 1.724-.041l.995-1.002v-.918a4.728 4.728 0 0 0-2.719-.1 5.76 5.76 0 0 0-.866.3l-.991-.574-1.188.685v.921l.407.233a1.002 1.002 0 0 0-.174.537v.917c0 .37.274.74.844 1.077a3.48 3.48 0 0 0 1.639.474c.11.005.22.005.329 0a6.673 6.673 0 0 0 1.761-.37l.34-.119-1.028.973v.922a4.885 4.885 0 0 0 3.833-.167l.98.566 1.188-.684v-.922l-.407-.236c.124-.172.193-.377.2-.589Zm-2.501-.081a2.548 2.548 0 0 1-2.216.166c.928-.325 1.705-.614 2.364-.262a1.195 1.195 0 0 1-.148.092v.004Z"
        fill="#FFD04E"
      />
      <path
        d="M28.66 152.359c-.407.103-.795.236-1.147.37-.403.146-.815.269-1.232.37a2.21 2.21 0 0 1-.584.055 1.228 1.228 0 0 1-.563-.17c-.37-.218-.44-.54.115-.907l.122-.074c.105-.06.214-.115.326-.162a2.211 2.211 0 0 1 1.724-.037l.995-1.003a4.728 4.728 0 0 0-2.72-.1 5.752 5.752 0 0 0-.865.3l-.992-.574-1.188.685.985.566c-.996.758-1.018 1.543.103 2.194.499.29 1.062.452 1.64.47h.329a6.512 6.512 0 0 0 1.76-.37c1.137-.37 2.062-.829 2.828-.389.514.3.37.67-.193.996-.09.052-.182.099-.277.14a2.54 2.54 0 0 1-1.976 0l-1.062 1.051a4.874 4.874 0 0 0 3.833-.166l.98.566 1.188-.685-.969-.562c.984-.766 1.11-1.595-.055-2.272a3.961 3.961 0 0 0-3.105-.292Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M28.66 152.359c-.407.103-.795.236-1.147.37-.403.146-.815.269-1.232.37a2.21 2.21 0 0 1-.584.055 1.228 1.228 0 0 1-.563-.17c-.37-.218-.44-.54.115-.907l.122-.074c.105-.06.214-.115.326-.162a2.211 2.211 0 0 1 1.724-.037l.995-1.003a4.728 4.728 0 0 0-2.72-.1 5.752 5.752 0 0 0-.865.3l-.992-.574-1.188.685.985.566c-.996.758-1.018 1.543.103 2.194.499.29 1.062.452 1.64.47h.329a6.512 6.512 0 0 0 1.76-.37c1.137-.37 2.062-.829 2.828-.389.514.3.37.67-.193.996-.09.052-.182.099-.277.14a2.54 2.54 0 0 1-1.976 0l-1.062 1.051a4.874 4.874 0 0 0 3.833-.166l.98.566 1.188-.685-.969-.562c.984-.766 1.11-1.595-.055-2.272a3.961 3.961 0 0 0-3.105-.292Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m22.64 151.112 1.2-.544.98.433-.992-.574-1.187.685Zm2.909-.374a5.59 5.59 0 0 1 2.55.086l-.69.98.996-1.003a4.729 4.729 0 0 0-2.856-.063Zm6.186 1.902c1.154.677 1.04 1.506.055 2.272.873-.954.714-1.617-.236-2.164a4.467 4.467 0 0 0-2.912-.4 3.969 3.969 0 0 1 3.093.292Zm.074 2.283.75.577-.957.673 1.187-.684-.98-.566Zm-2.006-.207a2.557 2.557 0 0 1-1.89.163l-1.11.895 1.04-1.047a2.542 2.542 0 0 0 1.96-.011Zm-3.533-1.617a1.544 1.544 0 0 1-1.42-.137c-.341-.292-.123-.611.37-.884-.556.37-.5.688-.115.906.17.102.363.16.562.17.203.009.405-.009.603-.055Zm-2.656-1.399c-.082.074-.796.74-.481 1.406.314.666 1.38 1.166 2.22 1.258a3.466 3.466 0 0 1-1.64-.47c-1.117-.666-1.095-1.454-.1-2.194Z"
        fill="#F5F5F5"
      />
      <path
        d="M19.71 150.705a7.528 7.528 0 0 1 2.797-2.59c4.574-2.642 11.992-2.642 16.565 0a7.529 7.529 0 0 1 2.798 2.59h.632v2.394c-.085 1.661-1.224 3.33-3.422 4.581-4.573 2.641-11.992 2.641-16.565 0-2.198-1.269-3.33-2.92-3.43-4.581v-2.394h.625Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M19.71 150.705a7.528 7.528 0 0 1 2.797-2.59c4.574-2.642 11.992-2.642 16.565 0a7.529 7.529 0 0 1 2.798 2.59h.632v2.394c-.085 1.661-1.224 3.33-3.422 4.581-4.573 2.641-11.992 2.641-16.565 0-2.198-1.269-3.33-2.92-3.43-4.581v-2.394h.625Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M30.788 146.15c3 0 5.998.663 8.284 1.984a7.529 7.529 0 0 1 2.798 2.59h.632v2.393c-.085 1.662-1.224 3.33-3.422 4.581-2.287 1.321-5.284 1.983-8.284 1.983l-.008-13.531Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M37.185 147.234c.653.242 1.284.538 1.887.885a7.528 7.528 0 0 1 2.798 2.59h.632v2.394c-.085 1.661-1.224 3.33-3.422 4.58a12.39 12.39 0 0 1-1.887.884l-.008-11.333Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M24.394 147.234a12.5 12.5 0 0 0-1.887.885 7.529 7.529 0 0 0-2.797 2.59h-.633v2.394c.085 1.661 1.232 3.33 3.43 4.58.603.347 1.234.643 1.887.884v-11.333Z"
        fill="#FFD04E"
      />
      <path
        d="M39.072 145.925c4.573 2.641 4.573 6.922 0 9.564-4.004 2.309-10.179 2.59-14.726.866l-.182-.07a12.712 12.712 0 0 1-1.657-.796c-3.815-2.22-4.44-5.55-1.898-8.14a8.811 8.811 0 0 1 1.898-1.435c4.573-2.631 11.991-2.631 16.565.011Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M39.072 145.925c4.573 2.641 4.573 6.922 0 9.564-4.004 2.309-10.179 2.59-14.726.866l-.182-.07a12.712 12.712 0 0 1-1.657-.796c-3.815-2.22-4.44-5.55-1.898-8.14a8.811 8.811 0 0 1 1.898-1.435c4.573-2.631 11.991-2.631 16.565.011Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M20.609 147.36a5.122 5.122 0 0 0-1.228 4.174c.407 2.324 3.659 4.281 4.784 4.751a12.71 12.71 0 0 1-1.658-.796c-3.815-2.205-4.447-5.546-1.898-8.129Zm20.361 6.69a5.11 5.11 0 0 0 1.228-4.17c-.407-2.323-3.663-4.281-4.784-4.751.572.224 1.126.49 1.658.796 3.814 2.201 4.447 5.546 1.898 8.125Z"
        fill="#F5F5F5"
      />
      <path
        d="M23.096 155.141c-4.252-2.453-4.252-6.434 0-8.88 4.251-2.445 11.144-2.453 15.4 0 4.254 2.453 4.25 6.438 0 8.88-4.252 2.442-11.149 2.457-15.4 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M23.096 155.141c-4.252-2.453-4.252-6.434 0-8.88 4.251-2.445 11.144-2.453 15.4 0 4.254 2.453 4.25 6.438 0 8.88-4.252 2.442-11.149 2.457-15.4 0Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M20.402 152.573c-.877-1.617-.592-3.4.854-4.913.285-.294.593-.564.922-.807.281-.211.575-.405.88-.581.174-.103.37-.2.537-.292-.452.74-.285 1.543 2.279 1.695 5.017.292-1.343 5.087-1.343 5.087s-3.234-1.561-4.13-.189Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M20.92 151.249c-.74-.085-1.11-.859-.837-1.732.274-.873 1.144-1.51 1.895-1.424.75.085 1.11.858.832 1.731-.277.873-1.14 1.506-1.89 1.425Z"
        fill="#fff"
      />
      <path
        d="M28.86 155.245c.248-1.85 8.392-7.03 8.392-7.03s1.809-.74 1.206-1.987c.302.17.594.358.873.562.189.137.37.274.53.419 2.423 2.101 2.426 4.858 0 6.959a7.6 7.6 0 0 1-.53.422 7.45 7.45 0 0 1-.806.525c-.29.156-.567.311-.866.452-.237.111-.485.218-.74.314-.256.097-.503.193-.762.278a15.979 15.979 0 0 1-2.979.662c-.806.105-1.618.155-2.43.152a18.12 18.12 0 0 1-2.96-.244s1.302-.259 1.072-1.484Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M28.86 155.245c.248-1.85 8.392-7.03 8.392-7.03s1.809-.74 1.206-1.987c.302.17.594.358.873.562.189.137.37.274.53.419 2.423 2.101 2.426 4.858 0 6.959a7.6 7.6 0 0 1-.53.422 7.45 7.45 0 0 1-.806.525c-.29.156-.567.311-.866.452-.237.111-.485.218-.74.314-.256.097-.503.193-.762.278a15.979 15.979 0 0 1-2.979.662c-.806.105-1.618.155-2.43.152a18.12 18.12 0 0 1-2.96-.244s1.302-.259 1.072-1.484Z"
        fill="#fff"
      />
      <path
        d="M36.534 147.386c3.038 1.754 3.16 4.551.37 6.394a7.52 7.52 0 0 1-.37.229c-3.17 1.828-8.302 1.828-11.47 0-3.167-1.828-3.17-4.81 0-6.623.13-.074.263-.148.4-.215 3.182-1.613 8.033-1.539 11.07.215Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M36.534 147.386c3.038 1.754 3.16 4.551.37 6.394a7.52 7.52 0 0 1-.37.229c-3.17 1.828-8.302 1.828-11.47 0-3.167-1.828-3.17-4.81 0-6.623.13-.074.263-.148.4-.215 3.182-1.613 8.033-1.539 11.07.215Z"
        fill="#000"
      />
      <path
        d="M30.795 155.175c4.283 0 7.755-2.005 7.755-4.477 0-2.473-3.472-4.477-7.755-4.477-4.283 0-7.755 2.004-7.755 4.477 0 2.472 3.472 4.477 7.755 4.477Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M30.795 155.175c4.283 0 7.755-2.005 7.755-4.477 0-2.473-3.472-4.477-7.755-4.477-4.283 0-7.755 2.004-7.755 4.477 0 2.472 3.472 4.477 7.755 4.477Z"
        fill="#000"
      />
      <path
        d="M36.26 148.781c-3.027-1.75-7.937-1.75-10.963 0-1.24.714-1.969 1.609-2.195 2.538.226.932.955 1.828 2.195 2.542 3.026 1.75 7.936 1.75 10.963 0 1.24-.714 1.972-1.61 2.198-2.542-.211-.929-.944-1.839-2.198-2.538Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M36.26 148.781c-3.027-1.75-7.937-1.75-10.963 0-1.24.714-1.969 1.609-2.195 2.538.226.932.955 1.828 2.195 2.542 3.026 1.75 7.936 1.75 10.963 0 1.24-.714 1.972-1.61 2.198-2.542-.211-.929-.944-1.839-2.198-2.538Z"
        fill="#000"
      />
      <path
        d="M35.675 152.045v-.925c0-.37-.262-.74-.825-1.077h-.022a3.99 3.99 0 0 0-3.075-.281 9.27 9.27 0 0 0-1.147.37c-.403.147-.814.27-1.232.37a2.08 2.08 0 0 1-.588.055 1.187 1.187 0 0 1-.485-.129l.04-.026.123-.074a2.59 2.59 0 0 1 .322-.163 2.23 2.23 0 0 1 1.724-.037l.988-1.018v-.921a4.763 4.763 0 0 0-2.72-.1 5.585 5.585 0 0 0-.862.3l-.995-.574-1.188.685v.921l.407.233a1.012 1.012 0 0 0-.174.537v.921c0 .37.274.74.848 1.077.497.29 1.06.452 1.635.47h.326a6.472 6.472 0 0 0 1.761-.37l.34-.119-.995 1.01v.922a4.89 4.89 0 0 0 3.833-.182l.985.567 1.184-.685v-.921l-.408-.233c.126-.177.196-.387.2-.603Zm-2.5-.078a2.562 2.562 0 0 1-2.216.166c.928-.329 1.704-.614 2.367-.262l-.152.096Z"
        fill="#FFD04E"
      />
      <path
        d="M31.754 149.747a9.27 9.27 0 0 0-1.147.37c-.404.147-.815.27-1.232.37a2.08 2.08 0 0 1-.589.055 1.225 1.225 0 0 1-.562-.166c-.37-.222-.437-.544.118-.907l.122-.077c.104-.061.212-.114.322-.159a2.248 2.248 0 0 1 1.724-.041l.996-1.003a4.763 4.763 0 0 0-2.72-.1 5.589 5.589 0 0 0-.862.3l-.995-.574-1.188.685.984.57c-.999.74-1.017 1.543.104 2.19.497.291 1.06.452 1.635.47h.33a6.472 6.472 0 0 0 1.76-.37c1.14-.37 2.062-.829 2.828-.37.514.296.37.67-.193.995a2.558 2.558 0 0 1-2.25.137l-1.057 1.058a4.85 4.85 0 0 0 3.833-.166l.98.536 1.195-.673-.98-.566c.988-.762 1.11-1.595-.052-2.268h-.022a3.98 3.98 0 0 0-3.082-.296Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M31.754 149.747a9.27 9.27 0 0 0-1.147.37c-.404.147-.815.27-1.232.37a2.08 2.08 0 0 1-.589.055 1.225 1.225 0 0 1-.562-.166c-.37-.222-.437-.544.118-.907l.122-.077c.104-.061.212-.114.322-.159a2.248 2.248 0 0 1 1.724-.041l.996-1.003a4.763 4.763 0 0 0-2.72-.1 5.589 5.589 0 0 0-.862.3l-.995-.574-1.188.685.984.57c-.999.74-1.017 1.543.104 2.19.497.291 1.06.452 1.635.47h.33a6.472 6.472 0 0 0 1.76-.37c1.14-.37 2.062-.829 2.828-.37.514.296.37.67-.193.995a2.558 2.558 0 0 1-2.25.137l-1.057 1.058a4.85 4.85 0 0 0 3.833-.166l.98.536 1.195-.673-.98-.566c.988-.762 1.11-1.595-.052-2.268h-.022a3.98 3.98 0 0 0-3.082-.296Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m25.737 148.5 1.195-.544.985.433-.996-.574-1.184.685Zm2.905-.37a5.494 5.494 0 0 1 2.549.085l-.688.977.995-1.003a4.721 4.721 0 0 0-2.856-.059Zm6.187 1.898h.022c1.15.674 1.04 1.506.052 2.268.873-.951.717-1.617-.233-2.164a4.504 4.504 0 0 0-2.916-.4 3.978 3.978 0 0 1 3.075.296Zm.073 2.283.75.577-.954.677 1.184-.688-.98-.566Zm-2.002-.207a2.572 2.572 0 0 1-1.89.166l-1.11.892 1.043-1.044a2.567 2.567 0 0 0 1.957-.014Zm-3.533-1.617a1.543 1.543 0 0 1-1.42-.133c-.345-.296-.126-.611.37-.885-.555.37-.5.685-.119.907.171.1.364.157.563.166a2.1 2.1 0 0 0 .606-.055Zm-2.657-1.41c-.084.074-.798.74-.484 1.402.315.663 1.384 1.166 2.22 1.258a3.45 3.45 0 0 1-1.635-.469c-1.118-.648-1.1-1.418-.1-2.191Z"
        fill="#F5F5F5"
      />
      <path
        d="M15.54 148a7.574 7.574 0 0 1 2.801-2.59c4.574-2.642 11.988-2.642 16.562 0a7.573 7.573 0 0 1 2.8 2.59h.633v2.394c-.081 1.661-1.22 3.311-3.422 4.581-4.574 2.641-11.988 2.641-16.562 0-2.201-1.27-3.33-2.92-3.433-4.581V148h.621Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M15.54 148a7.574 7.574 0 0 1 2.801-2.59c4.574-2.642 11.988-2.642 16.562 0a7.573 7.573 0 0 1 2.8 2.59h.633v2.394c-.081 1.661-1.22 3.311-3.422 4.581-4.574 2.641-11.988 2.641-16.562 0-2.201-1.27-3.33-2.92-3.433-4.581V148h.621Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M26.614 143.412c2.997 0 5.994.662 8.28 1.983a7.582 7.582 0 0 1 2.802 2.59h.633v2.394c-.082 1.662-1.221 3.312-3.423 4.581-2.287 1.321-5.284 1.983-8.28 1.983l-.012-13.531Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M33.012 144.511c.651.247 1.281.548 1.883.899a7.582 7.582 0 0 1 2.8 2.59h.634v2.394c-.082 1.662-1.221 3.312-3.423 4.581a12.58 12.58 0 0 1-1.883.884l-.011-11.348Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M20.217 144.511c-.651.247-1.281.548-1.883.899a7.582 7.582 0 0 0-2.793 2.59h-.64v2.394c.085 1.662 1.232 3.312 3.433 4.581a12.58 12.58 0 0 0 1.883.884v-11.348Z"
        fill="#FFD04E"
      />
      <path
        d="M34.898 143.19c4.573 2.642 4.573 6.923 0 9.565-4.003 2.309-10.182 2.59-14.73.866l-.188-.071a12.833 12.833 0 0 1-1.654-.795c-3.815-2.22-4.44-5.55-1.902-8.14a8.8 8.8 0 0 1 1.91-1.425c4.573-2.63 12.006-2.63 16.564 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M34.898 143.19c4.573 2.642 4.573 6.923 0 9.565-4.003 2.309-10.182 2.59-14.73.866l-.188-.071a12.833 12.833 0 0 1-1.654-.795c-3.815-2.22-4.44-5.55-1.902-8.14a8.8 8.8 0 0 1 1.91-1.425c4.573-2.63 12.006-2.63 16.564 0Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M16.431 144.637a5.116 5.116 0 0 0-1.224 4.174c.403 2.323 3.663 4.281 4.773 4.74a12.966 12.966 0 0 1-1.654-.796c-3.808-2.194-4.444-5.535-1.895-8.118Zm20.366 6.693a5.109 5.109 0 0 0 1.225-4.17c-.404-2.323-3.66-4.28-4.78-4.75.569.219 1.122.48 1.653.78 3.815 2.22 4.451 5.55 1.902 8.14Z"
        fill="#F5F5F5"
      />
      <path
        d="M18.918 152.418c-4.251-2.453-4.251-6.434 0-8.88 4.251-2.445 11.144-2.453 15.396 0 4.251 2.453 4.251 6.438 0 8.88-4.252 2.442-11.141 2.457-15.396 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M18.918 152.418c-4.251-2.453-4.251-6.434 0-8.88 4.251-2.445 11.144-2.453 15.396 0 4.251 2.453 4.251 6.438 0 8.88-4.252 2.442-11.141 2.457-15.396 0Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M16.224 149.85c-.873-1.617-.588-3.4.855-4.913a7.44 7.44 0 0 1 .925-.807c.277-.207.566-.398.866-.57.174-.103.37-.199.536-.292-.455.74-.288 1.543 2.276 1.695 5.02.292-1.34 5.087-1.34 5.087s-3.219-1.572-4.118-.2Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M16.743 148.526c-.74-.085-1.11-.858-.832-1.732.277-.873 1.14-1.509 1.894-1.424.755.085 1.11.858.832 1.732-.277.873-1.14 1.505-1.894 1.424Z"
        fill="#fff"
      />
      <path
        d="M24.679 152.522c.248-1.85 8.395-7.03 8.395-7.03s1.806-.74 1.206-1.987c.301.172.592.362.87.57.188.137.37.273.529.418 2.427 2.101 2.43 4.858 0 6.959-.163.145-.34.285-.53.422a7.03 7.03 0 0 1-.806.526c-.289.155-.566.31-.862.451a10.82 10.82 0 0 1-.74.315c-.255.096-.507.192-.766.277a16.01 16.01 0 0 1-2.43.585l-.545.077c-.806.105-1.618.155-2.43.152a18.12 18.12 0 0 1-2.96-.244s1.302-.267 1.069-1.491Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M24.679 152.522c.248-1.85 8.395-7.03 8.395-7.03s1.806-.74 1.206-1.987c.301.172.592.362.87.57.188.137.37.273.529.418 2.427 2.101 2.43 4.858 0 6.959-.163.145-.34.285-.53.422a7.03 7.03 0 0 1-.806.526c-.289.155-.566.31-.862.451a10.82 10.82 0 0 1-.74.315c-.255.096-.507.192-.766.277a16.01 16.01 0 0 1-2.43.585l-.545.077c-.806.105-1.618.155-2.43.152a18.12 18.12 0 0 1-2.96-.244s1.302-.267 1.069-1.491Z"
        fill="#fff"
      />
      <path
        d="M32.356 144.67c3.041 1.754 3.164 4.551.37 6.394a9.793 9.793 0 0 1-.37.229c-3.167 1.828-8.303 1.828-11.47 0s-3.167-4.81 0-6.623a7.98 7.98 0 0 1 .396-.214c3.19-1.636 8.036-1.547 11.074.214Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M32.356 144.67c3.041 1.754 3.164 4.551.37 6.394a9.793 9.793 0 0 1-.37.229c-3.167 1.828-8.303 1.828-11.47 0s-3.167-4.81 0-6.623a7.98 7.98 0 0 1 .396-.214c3.19-1.636 8.036-1.547 11.074.214Z"
        fill="#000"
      />
      <path
        d="M32.101 144.807c3.027 1.75 3.027 4.585 0 6.331-3.026 1.746-7.936 1.75-10.966 0-3.03-1.75-3.027-4.581 0-6.331 3.026-1.75 7.94-1.746 10.966 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M32.101 144.807c3.027 1.75 3.027 4.585 0 6.331-3.026 1.746-7.936 1.75-10.966 0-3.03-1.75-3.027-4.581 0-6.331 3.026-1.75 7.94-1.746 10.966 0Z"
        fill="#000"
      />
      <path
        d="M32.101 146.058c-3.026-1.75-7.936-1.75-10.966 0-1.236.714-1.969 1.609-2.195 2.538.226.932.959 1.828 2.194 2.542 3.03 1.75 7.94 1.75 10.967 0 1.24-.714 1.969-1.61 2.194-2.542-.225-.929-.954-1.824-2.194-2.538Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M32.101 146.058c-3.026-1.75-7.936-1.75-10.966 0-1.236.714-1.969 1.609-2.195 2.538.226.932.959 1.828 2.194 2.542 3.03 1.75 7.94 1.75 10.967 0 1.24-.714 1.969-1.61 2.194-2.542-.225-.929-.954-1.824-2.194-2.538Z"
        fill="#000"
      />
      <path
        d="M31.502 149.321v-.925c0-.37-.263-.74-.83-1.076a.03.03 0 0 0-.018 0 3.99 3.99 0 0 0-3.075-.282 9.27 9.27 0 0 0-1.146.37c-.404.147-.815.27-1.233.37a2.211 2.211 0 0 1-.584.056 1.242 1.242 0 0 1-.485-.13l.037-.026.122-.074c.105-.061.214-.116.326-.162a2.211 2.211 0 0 1 1.724-.037l.992-1.003v-.921a4.733 4.733 0 0 0-2.716-.1 5.748 5.748 0 0 0-.866.299l-.992-.573-1.198.673v.922l.407.233a.975.975 0 0 0-.174.536v.922c0 .37.274.74.843 1.076a3.466 3.466 0 0 0 1.64.47h.329a6.41 6.41 0 0 0 1.757-.37l.344-.118-.999 1.002v.922a4.885 4.885 0 0 0 3.834-.167l.98.566 1.188-.684v-.921l-.407-.234c.126-.18.195-.394.2-.614ZM29 149.244a3.224 3.224 0 0 1-.277.136 2.548 2.548 0 0 1-1.939.03c.929-.329 1.706-.614 2.364-.263-.044.034-.096.063-.148.097Z"
        fill="#FFD04E"
      />
      <path
        d="M27.58 147.024a9.27 9.27 0 0 0-1.147.37c-.404.146-.815.27-1.233.37a2.21 2.21 0 0 1-.584.055 1.26 1.26 0 0 1-.566-.166c-.37-.222-.437-.544.118-.911l.122-.074c.105-.06.214-.113.326-.159a2.265 2.265 0 0 1 1.724-.04l.992-1.003a4.75 4.75 0 0 0-2.716-.1 5.752 5.752 0 0 0-.866.3l-.992-.574-1.198.688.984.567c-.995.74-1.018 1.542.103 2.19.5.29 1.063.452 1.64.47h.329a6.447 6.447 0 0 0 1.757-.37c1.14-.37 2.061-.829 2.83-.37.515.296.37.67-.192.995a2.559 2.559 0 0 1-2.253.137l-1.04 1.043a4.85 4.85 0 0 0 3.834-.166l.98.566 1.188-.684-1.01-.57c.988-.762 1.11-1.595-.052-2.268a.03.03 0 0 0-.019 0 3.98 3.98 0 0 0-3.06-.296Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M27.58 147.024a9.27 9.27 0 0 0-1.147.37c-.404.146-.815.27-1.233.37a2.21 2.21 0 0 1-.584.055 1.26 1.26 0 0 1-.566-.166c-.37-.222-.437-.544.118-.911l.122-.074c.105-.06.214-.113.326-.159a2.265 2.265 0 0 1 1.724-.04l.992-1.003a4.75 4.75 0 0 0-2.716-.1 5.752 5.752 0 0 0-.866.3l-.992-.574-1.198.688.984.567c-.995.74-1.018 1.542.103 2.19.5.29 1.063.452 1.64.47h.329a6.447 6.447 0 0 0 1.757-.37c1.14-.37 2.061-.829 2.83-.37.515.296.37.67-.192.995a2.559 2.559 0 0 1-2.253.137l-1.04 1.043a4.85 4.85 0 0 0 3.834-.166l.98.566 1.188-.684-1.01-.57c.988-.762 1.11-1.595-.052-2.268a.03.03 0 0 0-.019 0 3.98 3.98 0 0 0-3.06-.296Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m21.56 145.777 1.198-.544.98.433-.99-.574-1.188.685Zm2.908-.367a5.494 5.494 0 0 1 2.55.085l-.69.977.996-1.003a4.729 4.729 0 0 0-2.856-.059Zm6.187 1.895a.03.03 0 0 1 .018 0c1.155.673 1.04 1.505.052 2.268.877-.951.718-1.617-.233-2.165a4.492 4.492 0 0 0-2.912-.399 3.98 3.98 0 0 1 3.075.296Zm.07 2.282.755.581-.959.674 1.188-.688-.984-.567Zm-2.002-.207a2.557 2.557 0 0 1-1.89.163l-1.11.896 1.04-1.044a2.56 2.56 0 0 0 1.96-.015Zm-3.533-1.617a1.531 1.531 0 0 1-1.42-.133c-.345-.296-.123-.61.388-.888-.555.37-.5.688-.119.91.173.1.367.157.566.167a2.21 2.21 0 0 0 .585-.056Zm-2.657-1.409c-.085.074-.8.74-.481 1.402.318.663 1.38 1.166 2.22 1.258a3.466 3.466 0 0 1-1.64-.47c-1.117-.647-1.095-1.435-.1-2.19Z"
        fill="#F5F5F5"
      />
      <path
        d="m16.269 146.79.296-2.238.296 2.238 3.881.17-3.881.171-.296 2.242-.296-2.242-3.881-.171 3.881-.17Z"
        fill="#fff"
      />
      <path
        d="M33.8 156.447a8.205 8.205 0 0 1 3.307-2.101c4.762-1.673 10.73.37 13.354 4.551a7.662 7.662 0 0 1 1.202 3.641l.51.174-.972 2.652c-.74 1.824-2.331 3.33-4.622 4.144-4.758 1.673-10.73-.37-13.353-4.551-1.254-2.012-1.51-4.158-.899-6.027l.973-2.656.5.173Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M33.8 156.447a8.205 8.205 0 0 1 3.307-2.101c4.762-1.673 10.73.37 13.354 4.551a7.662 7.662 0 0 1 1.202 3.641l.51.174-.972 2.652c-.74 1.824-2.331 3.33-4.622 4.144-4.758 1.673-10.73-.37-13.353-4.551-1.254-2.012-1.51-4.158-.899-6.027l.973-2.656.5.173Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M44.589 154.423c2.409.78 4.48 2.358 5.871 4.474a7.664 7.664 0 0 1 1.203 3.64l.51.174-.973 2.653c-.74 1.824-2.33 3.33-4.62 4.144a11.551 11.551 0 0 1-7.482-.081l5.49-15.004Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M49.298 157.402c.436.453.825.949 1.162 1.48a7.662 7.662 0 0 1 1.203 3.641l.51.174-.973 2.652c-.74 1.825-2.33 3.33-4.621 4.144a10.18 10.18 0 0 1-1.876.463l4.595-12.554Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M38.987 153.883c-.64.095-1.27.25-1.88.463a8.204 8.204 0 0 0-3.308 2.101l-.5-.174-.968 2.653c-.611 1.869-.37 4.015.899 6.028.34.528.729 1.024 1.161 1.48l4.596-12.551Z"
        fill="#FFD04E"
      />
      <path
        d="M51.352 156.466c2.612 4.185.873 8.935-3.889 10.608-4.166 1.461-9.25.085-12.21-3.09l-.114-.126a9.542 9.542 0 0 1-1.014-1.339c-2.18-3.489-1.332-7.374 1.772-9.535a8.56 8.56 0 0 1 2.113-1.073c4.75-1.669 10.726.366 13.342 4.555Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M51.352 156.466c2.612 4.185.873 8.935-3.889 10.608-4.166 1.461-9.25.085-12.21-3.09l-.114-.126a9.542 9.542 0 0 1-1.014-1.339c-2.18-3.489-1.332-7.374 1.772-9.535a8.56 8.56 0 0 1 2.113-1.073c4.75-1.669 10.726.366 13.342 4.555Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M35.89 152.984a7.68 7.68 0 0 0-2.682 4.292c-.618 2.687 1.21 5.75 1.924 6.583a9.552 9.552 0 0 1-1.014-1.34c-2.187-3.489-1.34-7.374 1.773-9.535Zm13.69 13.017a7.673 7.673 0 0 0 2.683-4.292c.617-2.686-1.21-5.75-1.924-6.583a9.61 9.61 0 0 1 1.013 1.34c2.18 3.489 1.332 7.374-1.772 9.535Z"
        fill="#F5F5F5"
      />
      <path
        d="M51.633 162.113c1.165-3.929-1.873-8.293-6.785-9.749-4.912-1.456-9.837.548-11.002 4.476-1.164 3.929 1.874 8.293 6.786 9.749 4.912 1.456 9.837-.548 11.001-4.476Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M51.633 162.113c1.165-3.929-1.873-8.293-6.785-9.749-4.912-1.456-9.837.548-11.002 4.476-1.164 3.929 1.874 8.293 6.786 9.749 4.912 1.456 9.837-.548 11.001-4.476Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M33.596 158.708a6.19 6.19 0 0 1 2.686-5.213c.34-.243.699-.458 1.073-.644.308-.151.624-.285.947-.399a7.84 7.84 0 0 1 .551-.178c-.67.703-.858 1.632 1.147 2.505 3.926 1.702-3.148 5.276-3.148 5.276s-1.972-2.623-3.256-1.347Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M34.555 157.38c-.574-.3-.559-1.262.03-2.146.588-.884 1.535-1.362 2.105-1.062.57.3.558 1.262-.03 2.15-.588.888-1.532 1.358-2.105 1.058Z"
        fill="#fff"
      />
      <path
        d="M39.328 163.995c.958-2.001 9.62-5.483 9.62-5.483s1.753-.307 1.783-1.872c.175.279.333.568.474.865.096.2.18.404.255.607 1.11 2.997-.019 6.057-2.83 7.722a7.527 7.527 0 0 1-.596.318 8.567 8.567 0 0 1-.866.37 7.95 7.95 0 0 1-.88.263 9.769 9.769 0 0 1-.719.152c-.24.04-.484.07-.74.092-.73.07-1.467.064-2.197-.018-.156-.019-.315-.037-.47-.063a11.844 11.844 0 0 1-2.024-.5 11.178 11.178 0 0 1-2.294-1.087s1.173.055 1.483-1.366Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M39.328 163.995c.958-2.001 9.62-5.483 9.62-5.483s1.753-.307 1.783-1.872c.175.279.333.568.474.865.096.2.18.404.255.607 1.11 2.997-.019 6.057-2.83 7.722a7.527 7.527 0 0 1-.596.318 8.567 8.567 0 0 1-.866.37 7.95 7.95 0 0 1-.88.263 9.769 9.769 0 0 1-.719.152c-.24.04-.484.07-.74.092-.73.07-1.467.064-2.197-.018-.156-.019-.315-.037-.47-.063a11.844 11.844 0 0 1-2.024-.5 11.178 11.178 0 0 1-2.294-1.087s1.173.055 1.483-1.366Z"
        fill="#fff"
      />
      <path
        d="M48.71 157.387c1.74 2.782.7 5.92-2.297 7.193a5.08 5.08 0 0 1-.393.151c-3.3 1.159-7.437-.251-9.25-3.152-1.813-2.901-.607-6.186 2.69-7.344.133-.049.27-.089.407-.13 3.23-.925 7.123.503 8.843 3.282Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M48.71 157.387c1.74 2.782.7 5.92-2.297 7.193a5.08 5.08 0 0 1-.393.151c-3.3 1.159-7.437-.251-9.25-3.152-1.813-2.901-.607-6.186 2.69-7.344.133-.049.27-.089.407-.13 3.23-.925 7.123.503 8.843 3.282Z"
        fill="#000"
      />
      <path
        d="M48.444 157.48c1.732 2.771.577 5.92-2.59 7.03-3.167 1.11-7.111-.241-8.84-3.012-1.727-2.771-.576-5.92 2.59-7.03 3.168-1.11 7.112.241 8.84 3.012Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M48.444 157.48c1.732 2.771.577 5.92-2.59 7.03-3.167 1.11-7.111-.241-8.84-3.012-1.727-2.771-.576-5.92 2.59-7.03 3.168-1.11 7.112.241 8.84 3.012Z"
        fill="#000"
      />
      <path
        d="M47.938 158.864c-1.732-2.772-5.687-4.122-8.84-3.012a5.092 5.092 0 0 0-2.8 2.22 4.809 4.809 0 0 0 .74 3.422c1.727 2.772 5.686 4.122 8.839 3.012a5.093 5.093 0 0 0 2.8-2.22 4.809 4.809 0 0 0-.74-3.422Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M47.938 158.864c-1.732-2.772-5.687-4.122-8.84-3.012a5.092 5.092 0 0 0-2.8 2.22 4.809 4.809 0 0 0 .74 3.422c1.727 2.772 5.686 4.122 8.839 3.012a5.093 5.093 0 0 0 2.8-2.22 4.809 4.809 0 0 0-.74-3.422Z"
        fill="#000"
      />
      <path
        d="M46.128 162.32c.06-.167.31-.848.37-1.025a1.606 1.606 0 0 0-.226-1.425v-.018c-.595-.951-1.48-1.162-2.364-1.158-.358.009-.714.036-1.07.081a7.911 7.911 0 0 1-1.15.081 1.453 1.453 0 0 1-.496-.1.797.797 0 0 1-.337-.277l.041-.019.13-.048c.106-.038.215-.069.325-.092a1.432 1.432 0 0 1 1.406.433l1.21-.84.37-1.021a2.96 2.96 0 0 0-2.15-.855 3.946 3.946 0 0 0-.817.092l-.57-.91-1.236.433-.37 1.021.233.37c-.163.153-.29.34-.37.548l-.37 1.017a1.61 1.61 0 0 0 .245 1.429 2.35 2.35 0 0 0 1.11.973l.266.089a4.352 4.352 0 0 0 1.572.059l.326-.037-1.217.84-.37 1.021c.91 1.014 2.13 1.11 3.16.869l.558.899 1.236-.436.37-1.021-.233-.37c.183-.168.326-.374.418-.603Zm-1.987-.774c-.09.033-.183.059-.277.078a1.623 1.623 0 0 1-1.576-.503c.884-.108 1.624-.211 2.016.37l-.163.055Z"
        fill="#FFD04E"
      />
      <path
        d="M43.9 158.693c-.357.01-.714.037-1.07.082a7.912 7.912 0 0 1-1.15.081 1.453 1.453 0 0 1-.496-.1.832.832 0 0 1-.37-.344c-.218-.348-.133-.721.463-.973l.13-.048c.105-.039.214-.069.325-.089a1.43 1.43 0 0 1 1.406.429l1.188-.851a2.97 2.97 0 0 0-2.15-.854c-.275.002-.55.033-.818.092l-.57-.91-1.235.433.562.899c-1.11.566-1.447 1.432-.806 2.461.26.438.656.78 1.128.973l.266.088a4.4 4.4 0 0 0 1.573.063c1.073-.111 1.998-.37 2.438.348.293.47.026.844-.562 1.051-.09.033-.183.059-.278.078a1.62 1.62 0 0 1-1.598-.529l-1.266.873c.91 1.017 2.132 1.11 3.16.869l.559.899 1.236-.436-.559-.896c1.11-.577 1.536-1.48.88-2.534v-.019c-.617-.928-1.516-1.139-2.386-1.136Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M43.9 158.693c-.357.01-.714.037-1.07.082a7.912 7.912 0 0 1-1.15.081 1.453 1.453 0 0 1-.496-.1.832.832 0 0 1-.37-.344c-.218-.348-.133-.721.463-.973l.13-.048c.105-.039.214-.069.325-.089a1.43 1.43 0 0 1 1.406.429l1.188-.851a2.97 2.97 0 0 0-2.15-.854c-.275.002-.55.033-.818.092l-.57-.91-1.235.433.562.899c-1.11.566-1.447 1.432-.806 2.461.26.438.656.78 1.128.973l.266.088a4.4 4.4 0 0 0 1.573.063c1.073-.111 1.998-.37 2.438.348.293.47.026.844-.562 1.051-.09.033-.183.059-.278.078a1.62 1.62 0 0 1-1.598-.529l-1.266.873c.91 1.017 2.132 1.11 3.16.869l.559.899 1.236-.436-.559-.896c1.11-.577 1.536-1.48.88-2.534v-.019c-.617-.928-1.516-1.139-2.386-1.136Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m39.553 155.656 1.187-.271.618.748-.57-.91-1.235.433Zm2.494.388a3.46 3.46 0 0 1 2.024.796l-.955.895 1.21-.855a2.965 2.965 0 0 0-2.28-.836Zm4.203 3.796v.019c.655 1.065.226 1.957-.88 2.534 1.11-.817 1.232-1.598.692-2.468a2.881 2.881 0 0 0-.95-.874 2.881 2.881 0 0 0-1.237-.369c.895.008 1.794.218 2.375 1.158Zm-.854 2.564.37.848-1.047.484 1.236-.433-.56-.899Zm-1.532-.78a1.641 1.641 0 0 1-1.591-.337l-1.273.681 1.265-.873a1.63 1.63 0 0 0 1.599.529Zm-2.191-2.764a1.007 1.007 0 0 1-1.091-.54c-.156-.422.148-.714.673-.877-.596.251-.68.625-.462.973.084.15.214.27.37.344.163.063.336.097.51.1Zm-1.569-2.298c-.096.059-.943.603-.958 1.428a2.384 2.384 0 0 0 1.28 2.006 2.346 2.346 0 0 1-1.128-.973c-.64-1.033-.304-1.895.806-2.461Z"
        fill="#F5F5F5"
      />
      <path
        d="m34.877 155.326 1.15-2.401-.673 2.564 3.06 1.254-3.2-.877-1.148 2.405.674-2.567-3.06-1.255 3.197.877Z"
        fill="#fff"
      />
      <path
        d="M149.525 146.402a6.286 6.286 0 0 1 2.342-2.165c3.826-2.22 10.03-2.22 13.86 0a6.357 6.357 0 0 1 2.342 2.165h.529v2.001c-.07 1.395-1.025 2.775-2.864 3.837-3.829 2.22-10.034 2.22-13.864 0-1.85-1.062-2.797-2.442-2.867-3.837v-2.001h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M149.525 146.402a6.286 6.286 0 0 1 2.342-2.165c3.826-2.22 10.03-2.22 13.86 0a6.357 6.357 0 0 1 2.342 2.165h.529v2.001c-.07 1.395-1.025 2.775-2.864 3.837-3.829 2.22-10.034 2.22-13.864 0-1.85-1.062-2.797-2.442-2.867-3.837v-2.001h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M158.793 142.58c2.509 0 5.017.551 6.934 1.657a6.357 6.357 0 0 1 2.342 2.165h.529v2.001c-.07 1.395-1.025 2.775-2.864 3.837-1.916 1.11-4.44 1.658-6.934 1.658l-.007-11.318Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M164.146 143.497a11.03 11.03 0 0 1 1.58.74 6.35 6.35 0 0 1 2.342 2.165h.53v2.001c-.071 1.395-1.025 2.775-2.864 3.837-.507.288-1.035.535-1.58.74l-.008-9.483Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M153.442 143.497c-.544.204-1.071.451-1.576.74a6.293 6.293 0 0 0-2.342 2.165h-.529v2.001c.07 1.395 1.029 2.775 2.871 3.837.505.289 1.032.536 1.576.74v-9.483Z"
        fill="#FFD04E"
      />
      <path
        d="M165.726 142.402c3.826 2.22 3.826 5.794 0 8.003-3.348 1.931-8.51 2.176-12.324.74l-.152-.059c-.478-.187-.94-.41-1.384-.666-3.193-1.85-3.726-4.64-1.591-6.801a7.372 7.372 0 0 1 1.591-1.202c3.826-2.224 10.031-2.224 13.86-.015Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M165.726 142.402c3.826 2.22 3.826 5.794 0 8.003-3.348 1.931-8.51 2.176-12.324.74l-.152-.059c-.478-.187-.94-.41-1.384-.666-3.193-1.85-3.726-4.64-1.591-6.801a7.372 7.372 0 0 1 1.591-1.202c3.826-2.224 10.031-2.224 13.86-.015Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M150.275 143.604a4.287 4.287 0 0 0-1.025 3.493c.337 1.943 3.06 3.582 4 3.974a10.12 10.12 0 0 1-1.384-.666c-3.193-1.843-3.726-4.625-1.591-6.801Zm17.039 5.598a4.274 4.274 0 0 0 1.028-3.492c-.34-1.943-3.063-3.582-4.003-3.974.478.187.942.41 1.387.666 3.19 1.842 3.734 4.64 1.588 6.8Z"
        fill="#F5F5F5"
      />
      <path
        d="M152.354 150.117c-3.555-2.058-3.555-5.388 0-7.441 3.556-2.054 9.328-2.054 12.887 0 3.56 2.053 3.56 5.383 0 7.441-3.559 2.057-9.327 2.053-12.887 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M152.354 150.117c-3.555-2.058-3.555-5.388 0-7.441 3.556-2.054 9.328-2.054 12.887 0 3.56 2.053 3.56 5.383 0 7.441-3.559 2.057-9.327 2.053-12.887 0Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M150.102 147.967c-.74-1.354-.492-2.845.714-4.111.238-.244.497-.467.773-.666.238-.175.485-.337.74-.484.148-.085.296-.167.452-.245-.37.622-.241 1.292 1.905 1.418 4.2.244-1.11 4.255-1.11 4.255s-2.723-1.318-3.474-.167Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M150.534 146.857c-.629-.07-.943-.718-.695-1.447.248-.729.954-1.265 1.583-1.195.629.07.944.74.696 1.451-.248.71-.955 1.261-1.584 1.191Z"
        fill="#fff"
      />
      <path
        d="M157.176 150.22c.207-1.561 7.03-5.875 7.03-5.875s1.51-.607 1.007-1.665c.255.143.502.3.74.47.159.114.307.233.444.37 2.031 1.757 2.031 4.07 0 5.823-.142.131-.29.255-.444.37a6.967 6.967 0 0 1-1.414.811 10.954 10.954 0 0 1-1.254.495 12.83 12.83 0 0 1-2.035.489 16.106 16.106 0 0 1-2.49.196 15.704 15.704 0 0 1-2.487-.204s1.099-.273.903-1.28Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M157.176 150.22c.207-1.561 7.03-5.875 7.03-5.875s1.51-.607 1.007-1.665c.255.143.502.3.74.47.159.114.307.233.444.37 2.031 1.757 2.031 4.07 0 5.823-.142.131-.29.255-.444.37a6.967 6.967 0 0 1-1.414.811 10.954 10.954 0 0 1-1.254.495 12.83 12.83 0 0 1-2.035.489 16.106 16.106 0 0 1-2.49.196 15.704 15.704 0 0 1-2.487-.204s1.099-.273.903-1.28Z"
        fill="#fff"
      />
      <path
        d="M163.602 143.623c2.542 1.48 2.646 3.811.311 5.35-.1.066-.203.129-.314.192-2.649 1.532-6.945 1.532-9.598 0-2.653-1.532-2.649-4.011 0-5.55.107-.063.222-.122.333-.177 2.668-1.358 6.723-1.281 9.268.185Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M163.602 143.623c2.542 1.48 2.646 3.811.311 5.35-.1.066-.203.129-.314.192-2.649 1.532-6.945 1.532-9.598 0-2.653-1.532-2.649-4.011 0-5.55.107-.063.222-.122.333-.177 2.668-1.358 6.723-1.281 9.268.185Z"
        fill="#000"
      />
      <path
        d="M163.384 143.745c2.535 1.48 2.535 3.837 0 5.298-2.534 1.462-6.641 1.462-9.172 0-2.531-1.461-2.535-3.833 0-5.298 2.534-1.465 6.641-1.462 9.172 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M163.384 143.745c2.535 1.48 2.535 3.837 0 5.298-2.534 1.462-6.641 1.462-9.172 0-2.531-1.461-2.535-3.833 0-5.298 2.534-1.465 6.641-1.462 9.172 0Z"
        fill="#000"
      />
      <path
        d="M163.385 144.792c-2.531-1.48-6.642-1.48-9.173 0-1.036.596-1.65 1.347-1.85 2.124.189.781.803 1.528 1.85 2.127 2.531 1.462 6.642 1.462 9.173 0 1.039-.599 1.65-1.346 1.85-2.127-.215-.766-.811-1.528-1.85-2.124Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M163.385 144.792c-2.531-1.48-6.642-1.48-9.173 0-1.036.596-1.65 1.347-1.85 2.124.189.781.803 1.528 1.85 2.127 2.531 1.462 6.642 1.462 9.173 0 1.039-.599 1.65-1.346 1.85-2.127-.215-.766-.811-1.528-1.85-2.124Z"
        fill="#000"
      />
      <path
        d="M162.885 147.523v-.774c0-.318-.218-.625-.692-.902h-.018a3.336 3.336 0 0 0-2.572-.233c-.34.085-.666.196-.958.296a9.266 9.266 0 0 1-1.032.321 1.986 1.986 0 0 1-.492.049 1.047 1.047 0 0 1-.407-.111l.033-.023.104-.063c.087-.05.177-.094.27-.133a1.87 1.87 0 0 1 1.443-.033l.832-.84v-.777a3.929 3.929 0 0 0-2.275-.081 4.526 4.526 0 0 0-.722.248l-.832-.478-.992.574v.769l.337.196a.827.827 0 0 0-.144.448v.77c0 .318.229.625.706.899.417.246.889.382 1.373.396h.274a5.646 5.646 0 0 0 1.48-.318l.288-.1-.839.84v.769a4.072 4.072 0 0 0 1.617.259 4.074 4.074 0 0 0 1.59-.396l.822.474.995-.574v-.773l-.344-.2a.864.864 0 0 0 .155-.499Zm-2.094-.067a2.132 2.132 0 0 1-1.854.141c.777-.274 1.429-.515 1.98-.219l-.126.078Z"
        fill="#FFD04E"
      />
      <path
        d="M159.603 145.603c-.34.085-.665.196-.958.296a9.486 9.486 0 0 1-1.032.322 2.034 2.034 0 0 1-.492.048 1.03 1.03 0 0 1-.47-.145c-.322-.181-.37-.451.096-.758l.104-.063c.087-.05.177-.095.27-.133a1.87 1.87 0 0 1 1.443-.033l.832-.84a3.938 3.938 0 0 0-2.275-.082 4.733 4.733 0 0 0-.722.248l-.832-.477-.992.573.825.481c-.836.633-.851 1.292.085 1.832.418.244.89.38 1.373.396h.274a5.646 5.646 0 0 0 1.48-.318c.955-.319 1.724-.696 2.368-.326.429.248.311.562-.163.832a2.136 2.136 0 0 1-1.883.115l-.873.873a4.06 4.06 0 0 0 3.208-.14l.821.477.995-.573-.821-.474c.825-.64.921-1.336-.045-1.902h-.018a3.321 3.321 0 0 0-2.598-.229Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M159.603 145.603c-.34.085-.665.196-.958.296a9.486 9.486 0 0 1-1.032.322 2.034 2.034 0 0 1-.492.048 1.03 1.03 0 0 1-.47-.145c-.322-.181-.37-.451.096-.758l.104-.063c.087-.05.177-.095.27-.133a1.87 1.87 0 0 1 1.443-.033l.832-.84a3.938 3.938 0 0 0-2.275-.082 4.733 4.733 0 0 0-.722.248l-.832-.477-.992.573.825.481c-.836.633-.851 1.292.085 1.832.418.244.89.38 1.373.396h.274a5.646 5.646 0 0 0 1.48-.318c.955-.319 1.724-.696 2.368-.326.429.248.311.562-.163.832a2.136 2.136 0 0 1-1.883.115l-.873.873a4.06 4.06 0 0 0 3.208-.14l.821.477.995-.573-.821-.474c.825-.64.921-1.336-.045-1.902h-.018a3.321 3.321 0 0 0-2.598-.229Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m154.567 144.559.999-.455.825.359-.832-.477-.992.573Zm2.431-.314a4.641 4.641 0 0 1 2.135.074l-.577.817.832-.84a3.986 3.986 0 0 0-2.39-.051Zm5.177 1.59h.019c.965.567.869 1.262.044 1.902.74-.799.599-1.354-.196-1.813a3.74 3.74 0 0 0-2.438-.333 3.337 3.337 0 0 1 2.571.244Zm.062 1.91.629.484-.803.566.996-.573-.822-.477Zm-1.657-.174a2.144 2.144 0 0 1-1.584.14l-.943.74.873-.873a2.13 2.13 0 0 0 1.654-.007Zm-2.96-1.351a1.295 1.295 0 0 1-1.191-.111c-.285-.248-.104-.514.325-.74-.462.307-.418.577-.096.759.143.085.304.135.47.144.165.003.331-.014.492-.052Zm-2.22-1.18c-.07.059-.669.618-.403 1.177.266.558 1.154.973 1.85 1.05a2.9 2.9 0 0 1-1.373-.395c-.943-.541-.928-1.199-.074-1.832Z"
        fill="#F5F5F5"
      />
      <path
        d="M148.055 143.693a6.29 6.29 0 0 1 2.342-2.164c3.826-2.22 10.031-2.22 13.86 0a6.322 6.322 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.025 2.771-2.863 3.833-3.83 2.22-10.035 2.22-13.861 0-1.85-1.062-2.8-2.442-2.871-3.833v-2.002h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M148.055 143.693a6.29 6.29 0 0 1 2.342-2.164c3.826-2.22 10.031-2.22 13.86 0a6.322 6.322 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.025 2.771-2.863 3.833-3.83 2.22-10.035 2.22-13.861 0-1.85-1.062-2.8-2.442-2.871-3.833v-2.002h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M157.327 139.86c2.509 0 5.017.551 6.93 1.657a6.325 6.325 0 0 1 2.342 2.165h.529v2.002c-.07 1.391-1.024 2.771-2.863 3.833-1.913 1.11-4.422 1.657-6.93 1.657l-.008-11.314Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M162.682 140.789c.544.203 1.072.451 1.576.74a6.325 6.325 0 0 1 2.342 2.165h.529v2.001c-.07 1.391-1.025 2.772-2.864 3.833-.504.29-1.031.537-1.576.74l-.007-9.479Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M151.974 140.789c-.545.202-1.073.45-1.576.74a6.288 6.288 0 0 0-2.343 2.165h-.529v2.001c.071 1.391 1.029 2.772 2.872 3.833.503.291 1.031.538 1.576.74v-9.479Z"
        fill="#FFD04E"
      />
      <path
        d="M164.258 139.694c3.829 2.22 3.826 5.79 0 7.999-3.349 1.935-8.51 2.176-12.325.74l-.152-.059c-.477-.188-.939-.41-1.383-.666-3.193-1.85-3.723-4.64-1.591-6.797a7.45 7.45 0 0 1 1.591-1.199c3.825-2.231 10.03-2.231 13.86-.018Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M164.258 139.694c3.829 2.22 3.826 5.79 0 7.999-3.349 1.935-8.51 2.176-12.325.74l-.152-.059c-.477-.188-.939-.41-1.383-.666-3.193-1.85-3.723-4.64-1.591-6.797a7.45 7.45 0 0 1 1.591-1.199c3.825-2.231 10.03-2.231 13.86-.018Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M148.807 140.896a4.275 4.275 0 0 0-1.025 3.489c.34 1.946 3.063 3.582 3.999 3.974-.477-.188-.939-.41-1.383-.666-3.193-1.843-3.723-4.64-1.591-6.797Zm17.042 5.598a4.296 4.296 0 0 0 1.025-3.493c-.341-1.946-3.064-3.581-4.004-3.974.479.187.943.41 1.388.666 3.193 1.843 3.722 4.64 1.591 6.801Z"
        fill="#F5F5F5"
      />
      <path
        d="M157.331 148.947c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.262-9.109-5.262-9.109 2.356-9.109 5.262c0 2.906 4.078 5.261 9.109 5.261Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M157.331 148.947c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.262-9.109-5.262-9.109 2.356-9.109 5.262c0 2.906 4.078 5.261 9.109 5.261Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M148.633 145.258c-.74-1.354-.492-2.849.718-4.114.237-.246.494-.471.769-.674.237-.177.484-.34.74-.488.145-.085.293-.167.448-.244-.37.625-.24 1.291 1.906 1.417 4.199.244-1.11 4.259-1.11 4.259s-2.72-1.307-3.471-.156Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M149.065 144.145c-.629-.07-.94-.718-.696-1.447.245-.729.955-1.262 1.584-1.191.629.07.944.718.699 1.446-.244.729-.954 1.266-1.587 1.192Z"
        fill="#fff"
      />
      <path
        d="M155.71 147.49c.204-1.558 7.03-5.876 7.03-5.876s1.51-.607 1.011-1.661c.255.142.502.299.74.47.155.114.303.229.44.37 2.031 1.757 2.035 4.07 0 5.823-.137.119-.285.237-.44.37a7.792 7.792 0 0 1-1.399.811 19.69 19.69 0 0 1-.614.266 8.641 8.641 0 0 1-.64.229 13.7 13.7 0 0 1-2.035.489l-.455.066a15.39 15.39 0 0 1-2.035.126 15.018 15.018 0 0 1-2.487-.203s1.077-.252.884-1.28Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M155.71 147.49c.204-1.558 7.03-5.876 7.03-5.876s1.51-.607 1.011-1.661c.255.142.502.299.74.47.155.114.303.229.44.37 2.031 1.757 2.035 4.07 0 5.823-.137.119-.285.237-.44.37a7.792 7.792 0 0 1-1.399.811 19.69 19.69 0 0 1-.614.266 8.641 8.641 0 0 1-.64.229 13.7 13.7 0 0 1-2.035.489l-.455.066a15.39 15.39 0 0 1-2.035.126 15.018 15.018 0 0 1-2.487-.203s1.077-.252.884-1.28Z"
        fill="#fff"
      />
      <path
        d="M162.134 140.915c2.542 1.48 2.645 3.811.311 5.35l-.311.192c-2.653 1.528-6.949 1.528-9.598 0-2.649-1.528-2.653-4.011 0-5.55l.333-.181c2.664-1.339 6.723-1.28 9.265.189Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M162.134 140.915c2.542 1.48 2.645 3.811.311 5.35l-.311.192c-2.653 1.528-6.949 1.528-9.598 0-2.649-1.528-2.653-4.011 0-5.55l.333-.181c2.664-1.339 6.723-1.28 9.265.189Z"
        fill="#000"
      />
      <path
        d="M157.332 147.43c3.584 0 6.489-1.676 6.489-3.744 0-2.068-2.905-3.745-6.489-3.745-3.585 0-6.49 1.677-6.49 3.745s2.905 3.744 6.49 3.744Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M157.332 147.43c3.584 0 6.489-1.676 6.489-3.744 0-2.068-2.905-3.745-6.489-3.745-3.585 0-6.49 1.677-6.49 3.745s2.905 3.744 6.49 3.744Z"
        fill="#000"
      />
      <path
        d="M161.92 142.08c-2.535-1.461-6.642-1.461-9.176 0-1.036.599-1.651 1.351-1.85 2.128.188.777.802 1.528 1.85 2.127 2.534 1.462 6.641 1.462 9.176 0 1.036-.599 1.646-1.35 1.85-2.127-.204-.777-.814-1.529-1.85-2.128Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M161.92 142.08c-2.535-1.461-6.642-1.461-9.176 0-1.036.599-1.651 1.351-1.85 2.128.188.777.802 1.528 1.85 2.127 2.534 1.462 6.641 1.462 9.176 0 1.036-.599 1.646-1.35 1.85-2.127-.204-.777-.814-1.529-1.85-2.128Z"
        fill="#000"
      />
      <path
        d="M161.416 144.814v-.773c0-.318-.219-.629-.692-.903a3.341 3.341 0 0 0-2.59-.237c-.341.089-.663.2-.959.3a9.251 9.251 0 0 1-1.032.318 1.77 1.77 0 0 1-.492.045 1.033 1.033 0 0 1-.403-.108l.029-.022.104-.063c.087-.05.177-.095.27-.133a1.853 1.853 0 0 1 1.443-.033l.833-.84v-.77a3.975 3.975 0 0 0-2.276-.085 5.08 5.08 0 0 0-.74.252l-.832-.481-.992.573v.77l.34.196a.82.82 0 0 0-.148.451v.766c0 .318.23.626.711.903.417.243.887.379 1.369.396h.274a5.255 5.255 0 0 0 1.48-.318l.288-.096-.84.839v.759a4.07 4.07 0 0 0 3.212-.141l.821.474.992-.574v-.769l-.341-.196a.901.901 0 0 0 .171-.5Zm-2.095-.066a2.144 2.144 0 0 1-1.853.14c.777-.277 1.428-.514 1.979-.222a.826.826 0 0 1-.126.082Z"
        fill="#FFD04E"
      />
      <path
        d="M158.134 142.891c-.341.088-.663.199-.959.299a9.256 9.256 0 0 1-1.032.319 1.809 1.809 0 0 1-.492.044 1.07 1.07 0 0 1-.47-.141c-.322-.185-.37-.455.096-.758a3.116 3.116 0 0 1 .374-.2 1.876 1.876 0 0 1 1.443-.03l.833-.839a3.975 3.975 0 0 0-2.276-.086 5.08 5.08 0 0 0-.74.252l-.832-.481-.992.574.821.473c-.836.637-.851 1.291.089 1.85.417.243.887.379 1.369.396h.274a5.398 5.398 0 0 0 1.48-.318c.955-.318 1.724-.692 2.368-.322.429.248.311.559-.163.832a2.136 2.136 0 0 1-1.883.115l-.873.877a4.067 4.067 0 0 0 3.211-.141l.822.474.991-.573-.825-.467c.825-.64.921-1.335-.044-1.898a3.341 3.341 0 0 0-2.59-.251Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M158.134 142.891c-.341.088-.663.199-.959.299a9.256 9.256 0 0 1-1.032.319 1.809 1.809 0 0 1-.492.044 1.07 1.07 0 0 1-.47-.141c-.322-.185-.37-.455.096-.758a3.116 3.116 0 0 1 .374-.2 1.876 1.876 0 0 1 1.443-.03l.833-.839a3.975 3.975 0 0 0-2.276-.086 5.08 5.08 0 0 0-.74.252l-.832-.481-.992.574.821.473c-.836.637-.851 1.291.089 1.85.417.243.887.379 1.369.396h.274a5.398 5.398 0 0 0 1.48-.318c.955-.318 1.724-.692 2.368-.322.429.248.311.559-.163.832a2.136 2.136 0 0 1-1.883.115l-.873.877a4.067 4.067 0 0 0 3.211-.141l.822.474.991-.573-.825-.467c.825-.64.921-1.335-.044-1.898a3.341 3.341 0 0 0-2.59-.251Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m153.099 141.847 1.002-.455.822.362-.833-.481-.991.574Zm2.43-.311a4.696 4.696 0 0 1 2.135.07l-.577.822.832-.84a3.948 3.948 0 0 0-2.39-.052Zm5.18 1.591c.966.563.87 1.258.045 1.898.74-.795.599-1.354-.197-1.813a3.778 3.778 0 0 0-2.438-.333 3.332 3.332 0 0 1 2.59.248Zm.06 1.91.629.484-.799.563.991-.574-.821-.473Zm-1.67-.175a2.122 2.122 0 0 1-1.583.137l-.944.74.873-.877a2.118 2.118 0 0 0 1.654 0Zm-2.959-1.35a1.3 1.3 0 0 1-1.192-.115c-.285-.248-.1-.51.326-.74-.463.304-.418.574-.096.759.143.082.304.131.47.14.165.008.33-.007.492-.044Zm-2.22-1.184c-.071.063-.67.622-.404 1.177.267.555 1.155.977 1.85 1.051a2.95 2.95 0 0 1-1.369-.396c-.936-.541-.921-1.195-.077-1.832Z"
        fill="#F5F5F5"
      />
      <path
        d="M148.795 140.112a6.39 6.39 0 0 1 2.342-2.165c3.83-2.22 10.035-2.22 13.86 0a6.328 6.328 0 0 1 2.343 2.165h.529v2.005c-.071 1.391-1.022 2.771-2.864 3.833-3.826 2.22-10.031 2.22-13.86 0-1.85-1.062-2.801-2.442-2.872-3.833v-2.005h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M148.795 140.112a6.39 6.39 0 0 1 2.342-2.165c3.83-2.22 10.035-2.22 13.86 0a6.328 6.328 0 0 1 2.343 2.165h.529v2.005c-.071 1.391-1.022 2.771-2.864 3.833-3.826 2.22-10.031 2.22-13.86 0-1.85-1.062-2.801-2.442-2.872-3.833v-2.005h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M158.067 136.29c2.509 0 5.018.555 6.93 1.657a6.352 6.352 0 0 1 2.343 2.165h.529v2.005c-.071 1.391-1.022 2.771-2.864 3.833-1.913 1.11-4.422 1.658-6.93 1.658l-.008-11.318Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M163.422 137.211c.545.202 1.072.45 1.576.74a6.363 6.363 0 0 1 2.342 2.164h.529v2.006c-.07 1.391-1.021 2.771-2.864 3.833-.503.29-1.031.538-1.576.74l-.007-9.483Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M152.718 137.211c-.546.203-1.075.45-1.58.74a6.386 6.386 0 0 0-2.342 2.164h-.529v2.006c.07 1.391 1.032 2.771 2.871 3.833.505.289 1.034.537 1.58.74v-9.483Z"
        fill="#FFD04E"
      />
      <path
        d="M164.998 136.112c3.83 2.22 3.83 5.794 0 8.003-3.348 1.935-8.51 2.176-12.321.74l-.152-.059c-.478-.187-.942-.41-1.387-.666-3.193-1.85-3.722-4.64-1.591-6.801a7.349 7.349 0 0 1 1.587-1.202c3.833-2.224 10.038-2.224 13.864-.015Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M164.998 136.112c3.83 2.22 3.83 5.794 0 8.003-3.348 1.935-8.51 2.176-12.321.74l-.152-.059c-.478-.187-.942-.41-1.387-.666-3.193-1.85-3.722-4.64-1.591-6.801a7.349 7.349 0 0 1 1.587-1.202c3.833-2.224 10.038-2.224 13.864-.015Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M149.547 137.314a4.285 4.285 0 0 0-1.025 3.493c.34 1.943 3.064 3.582 4.003 3.974a10.211 10.211 0 0 1-1.387-.666c-3.193-1.843-3.722-4.625-1.591-6.801Zm17.042 5.598a4.267 4.267 0 0 0 1.025-3.489c-.337-1.946-3.06-3.581-4-3.977.476.19.939.412 1.384.666 3.193 1.842 3.722 4.64 1.591 6.8Z"
        fill="#F5F5F5"
      />
      <path
        d="M158.071 145.369c5.031 0 9.11-2.355 9.11-5.261s-4.079-5.261-9.11-5.261-9.109 2.355-9.109 5.261 4.078 5.261 9.109 5.261Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M158.071 145.369c5.031 0 9.11-2.355 9.11-5.261s-4.079-5.261-9.11-5.261-9.109 2.355-9.109 5.261 4.078 5.261 9.109 5.261Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M149.376 141.677c-.74-1.354-.496-2.845.714-4.111.239-.247.497-.473.774-.677.237-.176.484-.337.74-.485.144-.085.296-.166.447-.244-.37.622-.24 1.291 1.906 1.417 4.199.244-1.11 4.259-1.11 4.259s-2.723-1.306-3.471-.159Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M149.809 140.567c-.633-.071-.944-.718-.699-1.447.244-.729.954-1.262 1.583-1.191.629.07.944.717.7 1.446-.245.729-.955 1.262-1.584 1.192Z"
        fill="#fff"
      />
      <path
        d="M156.451 143.93c.207-1.557 7.03-5.875 7.03-5.875s1.513-.607 1.01-1.665c.256.142.503.301.74.473.154.108.302.225.444.348 2.027 1.758 2.031 4.07 0 5.828a7.433 7.433 0 0 1-1.121.788c-.23.137-.47.262-.722.37-.251.107-.403.181-.614.262-.211.082-.422.159-.636.23-.665.217-1.345.382-2.035.492l-.459.063c-1.503.194-3.026.17-4.522-.074 0 0 1.081-.233.885-1.24Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M156.451 143.93c.207-1.557 7.03-5.875 7.03-5.875s1.513-.607 1.01-1.665c.256.142.503.301.74.473.154.108.302.225.444.348 2.027 1.758 2.031 4.07 0 5.828a7.433 7.433 0 0 1-1.121.788c-.23.137-.47.262-.722.37-.251.107-.403.181-.614.262-.211.082-.422.159-.636.23-.665.217-1.345.382-2.035.492l-.459.063c-1.503.194-3.026.17-4.522-.074 0 0 1.081-.233.885-1.24Z"
        fill="#fff"
      />
      <path
        d="M162.874 137.337c2.546 1.48 2.646 3.807.311 5.346-.1.067-.204.133-.311.192-2.649 1.532-6.948 1.532-9.598 0-2.649-1.531-2.653-4.01 0-5.55.108-.062.219-.125.333-.181 2.664-1.336 6.723-1.276 9.265.193Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M162.874 137.337c2.546 1.48 2.646 3.807.311 5.346-.1.067-.204.133-.311.192-2.649 1.532-6.948 1.532-9.598 0-2.649-1.531-2.653-4.01 0-5.55.108-.062.219-.125.333-.181 2.664-1.336 6.723-1.276 9.265.193Z"
        fill="#000"
      />
      <path
        d="M158.071 143.849c3.584 0 6.49-1.677 6.49-3.745s-2.906-3.744-6.49-3.744-6.49 1.676-6.49 3.744c0 2.068 2.906 3.745 6.49 3.745Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M158.071 143.849c3.584 0 6.49-1.677 6.49-3.745s-2.906-3.744-6.49-3.744-6.49 1.676-6.49 3.744c0 2.068 2.906 3.745 6.49 3.745Z"
        fill="#000"
      />
      <path
        d="M162.659 138.502c-2.535-1.461-6.642-1.461-9.176 0-1.036.6-1.647 1.347-1.85 2.128.189.777.799 1.528 1.85 2.124 2.534 1.48 6.641 1.48 9.176 0 1.036-.596 1.65-1.347 1.85-2.124-.2-.77-.814-1.51-1.85-2.128Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M162.659 138.502c-2.535-1.461-6.642-1.461-9.176 0-1.036.6-1.647 1.347-1.85 2.128.189.777.799 1.528 1.85 2.124 2.534 1.48 6.641 1.48 9.176 0 1.036-.596 1.65-1.347 1.85-2.124-.2-.77-.814-1.51-1.85-2.128Z"
        fill="#000"
      />
      <path
        d="M162.156 141.233v-.774c0-.318-.222-.625-.696-.902a3.32 3.32 0 0 0-2.59-.233c-.34.085-.666.196-.962.299-.337.125-.68.231-1.028.318a1.79 1.79 0 0 1-.489.049 1.052 1.052 0 0 1-.407-.108l.034-.022.099-.063a2.021 2.021 0 0 1 1.717-.17l.829-.836v-.781a3.987 3.987 0 0 0-2.272-.081 4.51 4.51 0 0 0-.74.251l-.829-.481-.995.574v.769l.341.196a.828.828 0 0 0-.145.448v.77c0 .318.23.625.707.903.416.243.887.378 1.369.392h.277a5.473 5.473 0 0 0 1.48-.318l.285-.1-.836.84v.769a4.061 4.061 0 0 0 3.208-.137l.821.474.992-.574v-.773l-.34-.196a.877.877 0 0 0 .17-.503Zm-2.091-.063a2.134 2.134 0 0 1-1.853.137c.777-.274 1.424-.515 1.979-.219l-.126.082Z"
        fill="#FFD04E"
      />
      <path
        d="M158.878 139.313c-.34.085-.666.196-.962.299-.337.125-.68.231-1.029.319a1.818 1.818 0 0 1-.488.048 1.084 1.084 0 0 1-.474-.141c-.318-.185-.37-.455.1-.758l.1-.063a2.021 2.021 0 0 1 1.717-.17l.829-.84a3.987 3.987 0 0 0-2.272-.082 4.61 4.61 0 0 0-.74.252l-.829-.481-.995.573.825.481c-.832.633-.851 1.292.089 1.85.416.243.887.378 1.369.392h.277a5.398 5.398 0 0 0 1.48-.318c.951-.318 1.725-.695 2.365-.325.429.251.31.562-.159.836a2.123 2.123 0 0 1-1.884.115l-.873.873a4.1 4.1 0 0 0 3.208-.137l.821.473.992-.573-.821-.474c.825-.64.921-1.335-.045-1.901a3.327 3.327 0 0 0-2.601-.248Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M158.878 139.313c-.34.085-.666.196-.962.299-.337.125-.68.231-1.029.319a1.818 1.818 0 0 1-.488.048 1.084 1.084 0 0 1-.474-.141c-.318-.185-.37-.455.1-.758l.1-.063a2.021 2.021 0 0 1 1.717-.17l.829-.84a3.987 3.987 0 0 0-2.272-.082 4.61 4.61 0 0 0-.74.252l-.829-.481-.995.573.825.481c-.832.633-.851 1.292.089 1.85.416.243.887.378 1.369.392h.277a5.398 5.398 0 0 0 1.48-.318c.951-.318 1.725-.695 2.365-.325.429.251.31.562-.159.836a2.123 2.123 0 0 1-1.884.115l-.873.873a4.1 4.1 0 0 0 3.208-.137l.821.473.992-.573-.821-.474c.825-.64.921-1.335-.045-1.901a3.327 3.327 0 0 0-2.601-.248Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m153.839 138.269 1.003-.455.821.363-.829-.481-.995.573Zm2.434-.311a4.588 4.588 0 0 1 2.132.071l-.574.817.833-.84a3.959 3.959 0 0 0-2.391-.048Zm5.177 1.587c.965.567.869 1.262.044 1.902.74-.799.599-1.354-.196-1.813a3.757 3.757 0 0 0-2.435-.333 3.343 3.343 0 0 1 2.587.244Zm.058 1.913.629.485-.799.563.991-.574-.821-.474Zm-1.668-.173a2.144 2.144 0 0 1-1.58.137l-.944.74.874-.874a2.125 2.125 0 0 0 1.65-.003Zm-2.96-1.354a1.29 1.29 0 0 1-1.188-.111c-.289-.248-.104-.511.326-.74-.467.303-.419.573-.1.758.145.083.307.131.473.141.164.006.329-.01.489-.048Zm-2.22-1.181c-.071.063-.666.618-.404 1.177.263.558 1.158.973 1.85 1.05a2.884 2.884 0 0 1-1.369-.392c-.936-.544-.917-1.202-.077-1.835Z"
        fill="#F5F5F5"
      />
      <path
        d="M146.52 137.825a6.283 6.283 0 0 1 2.342-2.164c3.826-2.22 10.034-2.22 13.86 0a6.283 6.283 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.021 2.771-2.864 3.837-3.825 2.22-10.034 2.22-13.86 0-1.85-1.066-2.801-2.446-2.871-3.837v-2.002h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M146.52 137.825a6.283 6.283 0 0 1 2.342-2.164c3.826-2.22 10.034-2.22 13.86 0a6.283 6.283 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.021 2.771-2.864 3.837-3.825 2.22-10.034 2.22-13.86 0-1.85-1.066-2.801-2.446-2.871-3.837v-2.002h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M155.796 134.003c2.509 0 5.017.551 6.93 1.658a6.283 6.283 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.021 2.771-2.864 3.837-1.912 1.11-4.421 1.654-6.93 1.654l-.007-11.315Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M161.149 134.92c.545.203 1.073.45 1.577.74a6.301 6.301 0 0 1 2.342 2.165h.529v2.002c-.07 1.391-1.021 2.771-2.864 3.837-.505.288-1.032.536-1.576.74l-.008-9.484Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M150.441 134.92c-.545.203-1.072.45-1.576.74a6.328 6.328 0 0 0-2.346 2.165h-.529v2.002c.071 1.391 1.029 2.771 2.871 3.837a10.89 10.89 0 0 0 1.577.74l.003-9.484Z"
        fill="#FFD04E"
      />
      <path
        d="M162.726 133.826c3.829 2.22 3.829 5.79 0 7.999-3.349 1.935-8.51 2.176-12.321.74l-.152-.059c-.477-.188-.939-.41-1.384-.666-3.193-1.85-3.722-4.64-1.591-6.797a7.5 7.5 0 0 1 1.591-1.199c3.822-2.231 10.031-2.231 13.857-.018Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M162.726 133.826c3.829 2.22 3.829 5.79 0 7.999-3.349 1.935-8.51 2.176-12.321.74l-.152-.059c-.477-.188-.939-.41-1.384-.666-3.193-1.85-3.722-4.64-1.591-6.797a7.5 7.5 0 0 1 1.591-1.199c3.822-2.231 10.031-2.231 13.857-.018Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M147.26 135.028a4.267 4.267 0 0 0-1.025 3.489c.34 1.946 3.064 3.582 4 3.974-.477-.188-.94-.41-1.384-.666-3.178-1.843-3.708-4.64-1.591-6.797Zm17.057 5.598a4.296 4.296 0 0 0 1.024-3.493c-.34-1.946-3.063-3.582-3.999-3.974.477.188.939.41 1.384.666 3.193 1.843 3.722 4.64 1.591 6.801Z"
        fill="#F5F5F5"
      />
      <path
        d="M155.8 143.079c5.031 0 9.109-2.356 9.109-5.261 0-2.906-4.078-5.262-9.109-5.262s-9.11 2.356-9.11 5.262c0 2.905 4.079 5.261 9.11 5.261Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M155.8 143.079c5.031 0 9.109-2.356 9.109-5.261 0-2.906-4.078-5.262-9.109-5.262s-9.11 2.356-9.11 5.262c0 2.905 4.079 5.261 9.11 5.261Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M147.101 139.39c-.74-1.354-.492-2.849.717-4.114.238-.246.495-.471.77-.674.237-.177.484-.34.74-.488.144-.085.292-.167.448-.244-.37.625-.241 1.291 1.905 1.417 4.2.244-1.11 4.258-1.11 4.258s-2.719-1.306-3.47-.155Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M147.534 138.28c-.629-.074-.94-.74-.696-1.45.244-.711.955-1.262 1.584-1.192.629.071.943.718.699 1.447-.244.729-.955 1.265-1.587 1.195Z"
        fill="#fff"
      />
      <path
        d="M154.178 141.621c.208-1.557 7.03-5.875 7.03-5.875s1.51-.607 1.011-1.662c.255.143.502.3.74.47.155.115.303.23.444.352 2.027 1.757 2.031 4.07 0 5.824a7.469 7.469 0 0 1-.441.351 7.92 7.92 0 0 1-1.398.81c-.248.111-.407.182-.615.267a8.481 8.481 0 0 1-.64.229 13.84 13.84 0 0 1-2.031.489l-.459.066a15.38 15.38 0 0 1-2.035.126 15.114 15.114 0 0 1-2.486-.203s1.073-.215.88-1.244Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M154.178 141.621c.208-1.557 7.03-5.875 7.03-5.875s1.51-.607 1.011-1.662c.255.143.502.3.74.47.155.115.303.23.444.352 2.027 1.757 2.031 4.07 0 5.824a7.469 7.469 0 0 1-.441.351 7.92 7.92 0 0 1-1.398.81c-.248.111-.407.182-.615.267a8.481 8.481 0 0 1-.64.229 13.84 13.84 0 0 1-2.031.489l-.459.066a15.38 15.38 0 0 1-2.035.126 15.114 15.114 0 0 1-2.486-.203s1.073-.215.88-1.244Z"
        fill="#fff"
      />
      <path
        d="M160.602 135.05c2.542 1.48 2.645 3.811.311 5.35l-.311.193c-2.653 1.528-6.949 1.528-9.598 0-2.649-1.529-2.653-4.011 0-5.55l.333-.182c2.664-1.343 6.723-1.291 9.265.189Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M160.602 135.05c2.542 1.48 2.645 3.811.311 5.35l-.311.193c-2.653 1.528-6.949 1.528-9.598 0-2.649-1.529-2.653-4.011 0-5.55l.333-.182c2.664-1.343 6.723-1.291 9.265.189Z"
        fill="#000"
      />
      <path
        d="M155.799 141.562c3.585 0 6.49-1.676 6.49-3.744 0-2.068-2.905-3.745-6.49-3.745-3.584 0-6.489 1.677-6.489 3.745s2.905 3.744 6.489 3.744Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M155.799 141.562c3.585 0 6.49-1.676 6.49-3.744 0-2.068-2.905-3.745-6.49-3.745-3.584 0-6.489 1.677-6.489 3.745s2.905 3.744 6.489 3.744Z"
        fill="#000"
      />
      <path
        d="M160.387 136.212c-2.534-1.462-6.66-1.462-9.176 0-1.036.599-1.646 1.35-1.85 2.127.189.777.8 1.528 1.85 2.128 2.535 1.461 6.642 1.461 9.176 0 1.036-.6 1.647-1.351 1.85-2.128-.203-.777-.814-1.528-1.85-2.127Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M160.387 136.212c-2.534-1.462-6.66-1.462-9.176 0-1.036.599-1.646 1.35-1.85 2.127.189.777.8 1.528 1.85 2.128 2.535 1.461 6.642 1.461 9.176 0 1.036-.6 1.647-1.351 1.85-2.128-.203-.777-.814-1.528-1.85-2.127Z"
        fill="#000"
      />
      <path
        d="M159.884 138.946v-.773c0-.318-.218-.629-.691-.903a3.328 3.328 0 0 0-2.59-.237c-.341.086-.663.197-.959.296a9.05 9.05 0 0 1-1.032.319 1.809 1.809 0 0 1-.492.044 1.045 1.045 0 0 1-.403-.107l.033-.022.1-.063c.087-.05.177-.094.27-.134.226-.101.47-.157.718-.163.248-.005.494.039.725.13l.832-.84v-.769a3.963 3.963 0 0 0-2.275-.085 4.974 4.974 0 0 0-.722.251l-.832-.481-.992.574v.769l.341.196a.842.842 0 0 0-.148.452v.766c0 .318.225.625.706.902.417.243.887.379 1.369.396h.274a5.248 5.248 0 0 0 1.48-.318l.289-.096-.855.832v.77a4.078 4.078 0 0 0 1.618.26 4.08 4.08 0 0 0 1.59-.401l.821.474.992-.573v-.77l-.34-.196a.898.898 0 0 0 .173-.5Zm-2.094-.066a2.14 2.14 0 0 1-1.853.14c.777-.277 1.428-.514 1.979-.222a.757.757 0 0 1-.126.082Z"
        fill="#FFD04E"
      />
      <path
        d="M156.603 137.022c-.341.085-.663.196-.959.296a9.046 9.046 0 0 1-1.032.318 1.77 1.77 0 0 1-.492.045 1.063 1.063 0 0 1-.47-.141c-.318-.185-.37-.455.1-.758l.1-.063c.092-.052.181-.096.27-.137a1.875 1.875 0 0 1 1.443-.03l.832-.84a3.98 3.98 0 0 0-2.275-.085 5.1 5.1 0 0 0-.722.252l-.832-.481-.992.573.822.478c-.833.636-.851 1.291.088 1.85.417.242.887.378 1.369.396.092.005.183.005.274 0a5.284 5.284 0 0 0 1.48-.319c.955-.318 1.728-.691 2.368-.321.429.247.311.558-.163.832a2.136 2.136 0 0 1-1.883.115l-.899.88a4.06 4.06 0 0 0 3.208-.14l.821.473.992-.573-.821-.474c.825-.64.921-1.335-.045-1.898a3.336 3.336 0 0 0-2.582-.248Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M156.603 137.022c-.341.085-.663.196-.959.296a9.046 9.046 0 0 1-1.032.318 1.77 1.77 0 0 1-.492.045 1.063 1.063 0 0 1-.47-.141c-.318-.185-.37-.455.1-.758l.1-.063c.092-.052.181-.096.27-.137a1.875 1.875 0 0 1 1.443-.03l.832-.84a3.98 3.98 0 0 0-2.275-.085 5.1 5.1 0 0 0-.722.252l-.832-.481-.992.573.822.478c-.833.636-.851 1.291.088 1.85.417.242.887.378 1.369.396.092.005.183.005.274 0a5.284 5.284 0 0 0 1.48-.319c.955-.318 1.728-.691 2.368-.321.429.247.311.558-.163.832a2.136 2.136 0 0 1-1.883.115l-.899.88a4.06 4.06 0 0 0 3.208-.14l.821.473.992-.573-.821-.474c.825-.64.921-1.335-.045-1.898a3.336 3.336 0 0 0-2.582-.248Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m151.566 135.979 1.003-.452.821.359-.832-.481-.992.574Zm2.431-.311a4.696 4.696 0 0 1 2.135.07l-.577.822.832-.84a3.948 3.948 0 0 0-2.39-.052Zm5.181 1.602c.966.563.869 1.258.044 1.898.74-.795.6-1.354-.196-1.813a3.786 3.786 0 0 0-2.438-.333 3.332 3.332 0 0 1 2.59.248Zm.059 1.898.629.485-.8.563.992-.574-.821-.474Zm-1.676-.174a2.12 2.12 0 0 1-1.58.137l-.944.74.87-.877a2.132 2.132 0 0 0 1.654 0Zm-2.957-1.354a1.288 1.288 0 0 1-1.187-.115c-.289-.248-.104-.51.325-.74-.466.304-.418.574-.1.759.144.082.305.131.47.14.165.008.331-.007.492-.044Zm-2.223-1.18c-.071.063-.666.622-.404 1.177.263.555 1.155.976 1.85 1.05a2.923 2.923 0 0 1-1.369-.396c-.928-.54-.91-1.195-.077-1.831Z"
        fill="#F5F5F5"
      />
      <path
        d="M148.603 134.639a6.287 6.287 0 0 1 2.357-2.179c3.825-2.22 10.03-2.22 13.86 0a6.363 6.363 0 0 1 2.342 2.164h.529v2.002c-.07 1.395-1.025 2.775-2.864 3.837-3.829 2.22-10.034 2.22-13.86 0-1.85-1.062-2.801-2.442-2.871-3.837v-2.002l.507.015Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M148.603 134.639a6.287 6.287 0 0 1 2.357-2.179c3.825-2.22 10.03-2.22 13.86 0a6.363 6.363 0 0 1 2.342 2.164h.529v2.002c-.07 1.395-1.025 2.775-2.864 3.837-3.829 2.22-10.034 2.22-13.86 0-1.85-1.062-2.801-2.442-2.871-3.837v-2.002l.507.015Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M157.875 130.817c2.505 0 5.017.552 6.93 1.658a6.363 6.363 0 0 1 2.342 2.164h.529v2.002c-.07 1.395-1.025 2.775-2.864 3.837-1.912 1.11-4.44 1.658-6.93 1.658l-.007-11.319Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M163.226 131.72a11.07 11.07 0 0 1 1.579.74 6.352 6.352 0 0 1 2.343 2.165h.529v2.001c-.071 1.395-1.025 2.775-2.864 3.837-.506.288-1.035.536-1.58.74l-.007-9.483Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M152.522 131.72a10.89 10.89 0 0 0-1.577.74 6.301 6.301 0 0 0-2.342 2.165h-.529v2.001c.071 1.395 1.029 2.775 2.871 3.837.505.289 1.032.536 1.577.74v-9.483Z"
        fill="#FFD04E"
      />
      <path
        d="M164.806 130.64c3.825 2.22 3.825 5.794 0 8.003-3.349 1.931-8.51 2.175-12.325.74l-.152-.059c-.477-.187-.94-.41-1.384-.666-3.193-1.85-3.722-4.64-1.591-6.801a7.401 7.401 0 0 1 1.591-1.203c3.826-2.223 10.031-2.223 13.861-.014Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M164.806 130.64c3.825 2.22 3.825 5.794 0 8.003-3.349 1.931-8.51 2.175-12.325.74l-.152-.059c-.477-.187-.94-.41-1.384-.666-3.193-1.85-3.722-4.64-1.591-6.801a7.401 7.401 0 0 1 1.591-1.203c3.826-2.223 10.031-2.223 13.861-.014Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M149.354 131.842a4.286 4.286 0 0 0-1.024 3.489c.336 1.947 3.059 3.586 3.999 3.978-.477-.187-.94-.41-1.384-.666-3.193-1.843-3.722-4.64-1.591-6.801Zm17.042 5.598a4.3 4.3 0 0 0 1.025-3.493c-.34-1.942-3.063-3.581-4.003-3.973.478.187.942.41 1.387.666 3.175 1.842 3.723 4.639 1.591 6.8Z"
        fill="#F5F5F5"
      />
      <path
        d="M157.879 139.893c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.261-9.109-5.261-9.109 2.355-9.109 5.261 4.078 5.261 9.109 5.261Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M157.879 139.893c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.261-9.109-5.261-9.109 2.355-9.109 5.261 4.078 5.261 9.109 5.261Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M166.574 136.205c.74-1.355.496-2.846-.714-4.111a5.785 5.785 0 0 0-.773-.677 8.7 8.7 0 0 0-1.188-.729c.37.622.237 1.291-1.909 1.417-4.196.244 1.11 4.255 1.11 4.255s2.723-1.31 3.474-.155Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M166.13 135.094c.629-.07.944-.718.7-1.446-.245-.729-.955-1.266-1.588-1.196-.632.071-.94.722-.695 1.451.244.729.965 1.262 1.583 1.191Z"
        fill="#fff"
      />
      <path
        d="M159.499 138.44c-.207-1.562-7.03-5.876-7.03-5.876s-1.513-.607-1.01-1.665c-.255.143-.502.3-.74.47a6.675 6.675 0 0 0-.444.351c-2.028 1.758-2.031 4.07 0 5.824.142.125.29.242.444.352.216.159.441.306.673.44.24.136.487.26.74.37.197.096.404.185.615.266a12.826 12.826 0 0 0 2.671.718 16.042 16.042 0 0 0 2.49.196 15.85 15.85 0 0 0 2.49-.203s-1.095-.219-.899-1.243Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M159.499 138.44c-.207-1.562-7.03-5.876-7.03-5.876s-1.513-.607-1.01-1.665c-.255.143-.502.3-.74.47a6.675 6.675 0 0 0-.444.351c-2.028 1.758-2.031 4.07 0 5.824.142.125.29.242.444.352.216.159.441.306.673.44.24.136.487.26.74.37.197.096.404.185.615.266a12.826 12.826 0 0 0 2.671.718 16.042 16.042 0 0 0 2.49.196 15.85 15.85 0 0 0 2.49-.203s-1.095-.219-.899-1.243Z"
        fill="#fff"
      />
      <path
        d="M153.076 131.861c-2.545 1.48-2.649 3.811-.311 5.35.097.066.204.129.311.192 2.649 1.532 6.945 1.532 9.598 0 2.653-1.532 2.653-4.011 0-5.55a6.608 6.608 0 0 0-.333-.177c-2.668-1.344-6.723-1.281-9.265.185Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M153.076 131.861c-2.545 1.48-2.649 3.811-.311 5.35.097.066.204.129.311.192 2.649 1.532 6.945 1.532 9.598 0 2.653-1.532 2.653-4.011 0-5.55a6.608 6.608 0 0 0-.333-.177c-2.668-1.344-6.723-1.281-9.265.185Z"
        fill="#000"
      />
      <path
        d="M157.878 138.376c3.585 0 6.49-1.676 6.49-3.744 0-2.068-2.905-3.744-6.49-3.744-3.584 0-6.489 1.676-6.489 3.744 0 2.068 2.905 3.744 6.489 3.744Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M157.878 138.376c3.585 0 6.49-1.676 6.49-3.744 0-2.068-2.905-3.744-6.49-3.744-3.584 0-6.489 1.676-6.489 3.744 0 2.068 2.905 3.744 6.489 3.744Z"
        fill="#000"
      />
      <path
        d="M153.29 133.03c2.535-1.48 6.642-1.48 9.176 0 1.036.596 1.647 1.347 1.85 2.124-.188.78-.799 1.528-1.85 2.127-2.534 1.48-6.66 1.48-9.176 0-1.036-.599-1.65-1.347-1.85-2.127.2-.777.814-1.528 1.85-2.124Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M153.29 133.03c2.535-1.48 6.642-1.48 9.176 0 1.036.596 1.647 1.347 1.85 2.124-.188.78-.799 1.528-1.85 2.127-2.534 1.48-6.66 1.48-9.176 0-1.036-.599-1.65-1.347-1.85-2.127.2-.777.814-1.528 1.85-2.124Z"
        fill="#000"
      />
      <path
        d="M161.964 135.76v-.773c0-.318-.219-.625-.692-.903h-.019a3.33 3.33 0 0 0-2.571-.233c-.341.085-.666.196-.959.296a9.27 9.27 0 0 1-1.032.322 1.939 1.939 0 0 1-.492.048 1.051 1.051 0 0 1-.407-.111l.033-.022.104-.063c.087-.05.177-.095.27-.133a1.87 1.87 0 0 1 1.443-.033l.832-.84v-.781a3.929 3.929 0 0 0-2.275-.081 4.623 4.623 0 0 0-.722.247l-.832-.477-.992.574v.773l.337.196a.833.833 0 0 0-.144.448v.769c0 .319.229.626.706.899.417.246.889.383 1.373.396h.274a5.566 5.566 0 0 0 1.48-.318l.289-.1-.84.84v.77a4.092 4.092 0 0 0 3.208-.137l.821.473.995-.573v-.77l-.34-.199a.904.904 0 0 0 .152-.504Zm-2.095-.066a2.125 2.125 0 0 1-1.853.14c.777-.273 1.428-.514 1.979-.218l-.126.078Z"
        fill="#FFD04E"
      />
      <path
        d="M158.682 133.84c-.341.085-.666.196-.959.296a9.27 9.27 0 0 1-1.032.322 1.939 1.939 0 0 1-.492.048 1.03 1.03 0 0 1-.47-.144c-.322-.182-.37-.452.096-.759l.104-.063c.087-.05.177-.094.27-.133a1.888 1.888 0 0 1 1.443-.033l.832-.84a3.929 3.929 0 0 0-2.275-.081 4.623 4.623 0 0 0-.722.247l-.832-.477-.992.574.822.473c-.836.633-.851 1.292.085 1.85.417.245.889.381 1.373.396h.273a5.55 5.55 0 0 0 1.48-.318c.955-.318 1.725-.696 2.368-.326.43.248.311.563-.162.833a2.136 2.136 0 0 1-1.884.115l-.873.873a4.077 4.077 0 0 0 3.208-.141l.821.477.996-.573-.84-.474c.825-.636.921-1.332-.045-1.898h-.018a3.339 3.339 0 0 0-2.575-.244Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M158.682 133.84c-.341.085-.666.196-.959.296a9.27 9.27 0 0 1-1.032.322 1.939 1.939 0 0 1-.492.048 1.03 1.03 0 0 1-.47-.144c-.322-.182-.37-.452.096-.759l.104-.063c.087-.05.177-.094.27-.133a1.888 1.888 0 0 1 1.443-.033l.832-.84a3.929 3.929 0 0 0-2.275-.081 4.623 4.623 0 0 0-.722.247l-.832-.477-.992.574.822.473c-.836.633-.851 1.292.085 1.85.417.245.889.381 1.373.396h.273a5.55 5.55 0 0 0 1.48-.318c.955-.318 1.725-.696 2.368-.326.43.248.311.563-.162.833a2.136 2.136 0 0 1-1.884.115l-.873.873a4.077 4.077 0 0 0 3.208-.141l.821.477.996-.573-.84-.474c.825-.636.921-1.332-.045-1.898h-.018a3.339 3.339 0 0 0-2.575-.244Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m153.646 132.797 1.003-.455.822.358-.833-.477-.992.574Zm2.431-.315a4.655 4.655 0 0 1 2.135.074l-.592.818.833-.84a3.98 3.98 0 0 0-2.376-.052Zm5.176 1.591h.019c.965.566.869 1.262.044 1.898.74-.795.599-1.35-.196-1.809a3.734 3.734 0 0 0-2.438-.333 3.327 3.327 0 0 1 2.571.244Zm.063 1.909.629.485-.802.566.995-.573-.822-.478Zm-1.676-.173a2.142 2.142 0 0 1-1.583.14l-.944.74.873-.873a2.123 2.123 0 0 0 1.654-.007Zm-2.957-1.351a1.304 1.304 0 0 1-1.191-.111c-.285-.248-.104-.514.326-.74-.463.307-.418.577-.097.758.143.086.304.135.47.145.166.003.331-.014.492-.052Zm-2.223-1.18c-.071.059-.67.618-.404 1.176.267.559 1.155.974 1.85 1.051a2.886 2.886 0 0 1-1.372-.396c-.925-.54-.911-1.198-.074-1.831Z"
        fill="#F5F5F5"
      />
      <path
        d="m166.127 133.566.244-1.876.248 1.876 3.248.145-3.248.14-.248 1.876-.244-1.876-3.249-.14 3.249-.145Z"
        fill="#fff"
      />
      <path
        d="M129.415 159.33a6.325 6.325 0 0 1 2.342-2.165c3.83-2.22 10.035-2.22 13.864 0a6.282 6.282 0 0 1 2.338 2.165h.53v1.99c-.074 1.395-1.025 2.775-2.864 3.837-3.83 2.22-10.035 2.22-13.864 0-1.85-1.062-2.801-2.442-2.871-3.837v-2.002l.525.012Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M129.415 159.33a6.325 6.325 0 0 1 2.342-2.165c3.83-2.22 10.035-2.22 13.864 0a6.282 6.282 0 0 1 2.338 2.165h.53v1.99c-.074 1.395-1.025 2.775-2.864 3.837-3.83 2.22-10.035 2.22-13.864 0-1.85-1.062-2.801-2.442-2.871-3.837v-2.002l.525.012Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M138.688 155.507c2.508 0 5.017.552 6.933 1.658a6.29 6.29 0 0 1 2.339 2.164h.529v1.991c-.074 1.395-1.025 2.775-2.864 3.837-1.917 1.11-4.44 1.658-6.934 1.658l-.003-11.308Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M144.041 156.425c.546.203 1.074.451 1.58.74a6.29 6.29 0 0 1 2.338 2.165h.529v1.99c-.074 1.395-1.024 2.775-2.863 3.837-.506.29-1.034.537-1.58.74l-.004-9.472Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M133.337 156.425c-.546.203-1.075.451-1.58.74a6.29 6.29 0 0 0-2.338 2.165h-.533v1.99c.07 1.395 1.032 2.775 2.871 3.837.505.29 1.034.537 1.58.74v-9.472Z"
        fill="#FFD04E"
      />
      <path
        d="M145.621 155.33c3.826 2.22 3.826 5.794 0 8.003-3.352 1.931-8.51 2.175-12.325.74l-.151-.059a11.635 11.635 0 0 1-1.388-.666c-3.189-1.85-3.722-4.64-1.587-6.801a7.45 7.45 0 0 1 1.587-1.199c3.83-2.227 10.035-2.227 13.864-.018Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M145.621 155.33c3.826 2.22 3.826 5.794 0 8.003-3.352 1.931-8.51 2.175-12.325.74l-.151-.059a11.635 11.635 0 0 1-1.388-.666c-3.189-1.85-3.722-4.64-1.587-6.801a7.45 7.45 0 0 1 1.587-1.199c3.83-2.227 10.035-2.227 13.864-.018Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M130.17 156.532a4.265 4.265 0 0 0-1.028 3.489c.34 1.947 3.063 3.582 4.003 3.978a11.47 11.47 0 0 1-1.387-.666c-3.19-1.843-3.737-4.64-1.588-6.801Zm17.038 5.599a4.287 4.287 0 0 0 1.025-3.493c-.337-1.943-3.06-3.582-4-3.974.478.187.94.409 1.384.666 3.193 1.843 3.726 4.64 1.591 6.801Z"
        fill="#F5F5F5"
      />
      <path
        d="M138.691 164.584c5.031 0 9.11-2.356 9.11-5.262 0-2.905-4.079-5.261-9.11-5.261s-9.109 2.356-9.109 5.261c0 2.906 4.078 5.262 9.109 5.262Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M138.691 164.584c5.031 0 9.11-2.356 9.11-5.262 0-2.905-4.079-5.261-9.11-5.261s-9.109 2.356-9.109 5.261c0 2.906 4.078 5.262 9.109 5.262Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M129.996 160.895c-.74-1.355-.495-2.846.715-4.111.237-.248.496-.475.773-.677a7.57 7.57 0 0 1 .74-.489c.144-.085.296-.162.448-.24-.37.622-.237 1.291 1.909 1.413 4.196.248-1.11 4.259-1.11 4.259s-2.723-1.306-3.475-.155Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M130.429 159.785c-.629-.071-.944-.718-.7-1.447.244-.729.955-1.265 1.588-1.195.632.07.939.74.695 1.45-.244.711-.954 1.247-1.583 1.192Z"
        fill="#fff"
      />
      <path
        d="M137.071 163.129c.207-1.561 7.03-5.879 7.03-5.879s1.513-.607 1.01-1.661c.255.143.502.3.74.47.159.114.307.233.444.37 2.027 1.757 2.031 4.07 0 5.824-.142.124-.29.242-.444.351a8.226 8.226 0 0 1-1.399.818 7.569 7.569 0 0 1-.614.266c-.211.082-.422.159-.636.23-.665.216-1.345.379-2.035.488a16.23 16.23 0 0 1-2.49.196 15.493 15.493 0 0 1-2.49-.207s1.084-.241.884-1.266Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M137.071 163.129c.207-1.561 7.03-5.879 7.03-5.879s1.513-.607 1.01-1.661c.255.143.502.3.74.47.159.114.307.233.444.37 2.027 1.757 2.031 4.07 0 5.824-.142.124-.29.242-.444.351a8.226 8.226 0 0 1-1.399.818 7.569 7.569 0 0 1-.614.266c-.211.082-.422.159-.636.23-.665.216-1.345.379-2.035.488a16.23 16.23 0 0 1-2.49.196 15.493 15.493 0 0 1-2.49-.207s1.084-.241.884-1.266Z"
        fill="#fff"
      />
      <path
        d="M143.494 156.551c2.545 1.48 2.649 3.811.311 5.35-.097.067-.204.13-.311.192-2.649 1.532-6.945 1.532-9.598 0-2.653-1.531-2.653-4.01 0-5.55.108-.061.219-.12.333-.177 2.671-1.336 6.741-1.284 9.265.185Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M143.494 156.551c2.545 1.48 2.649 3.811.311 5.35-.097.067-.204.13-.311.192-2.649 1.532-6.945 1.532-9.598 0-2.653-1.531-2.653-4.01 0-5.55.108-.061.219-.12.333-.177 2.671-1.336 6.741-1.284 9.265.185Z"
        fill="#000"
      />
      <path
        d="M138.691 163.066c3.584 0 6.49-1.676 6.49-3.744 0-2.068-2.906-3.744-6.49-3.744s-6.49 1.676-6.49 3.744c0 2.068 2.906 3.744 6.49 3.744Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M138.691 163.066c3.584 0 6.49-1.676 6.49-3.744 0-2.068-2.906-3.744-6.49-3.744s-6.49 1.676-6.49 3.744c0 2.068 2.906 3.744 6.49 3.744Z"
        fill="#000"
      />
      <path
        d="M143.279 157.72c-2.535-1.48-6.642-1.48-9.176 0-1.036.596-1.647 1.347-1.85 2.124.189.781.799 1.528 1.85 2.128 2.534 1.461 6.641 1.461 9.176 0 1.036-.6 1.65-1.347 1.85-2.128-.2-.777-.829-1.528-1.85-2.124Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M143.279 157.72c-2.535-1.48-6.642-1.48-9.176 0-1.036.596-1.647 1.347-1.85 2.124.189.781.799 1.528 1.85 2.128 2.534 1.461 6.641 1.461 9.176 0 1.036-.6 1.65-1.347 1.85-2.128-.2-.777-.829-1.528-1.85-2.124Z"
        fill="#000"
      />
      <path
        d="M142.78 160.451v-.773c0-.319-.222-.626-.692-.903a3.32 3.32 0 0 0-2.59-.233c-.34.085-.666.196-.962.296-.336.127-.68.234-1.028.322-.16.037-.325.052-.489.044a.977.977 0 0 1-.407-.107l.033-.023.1-.062c.089-.051.18-.095.274-.134a1.876 1.876 0 0 1 1.443-.033l.833-.84v-.769a3.94 3.94 0 0 0-2.276-.082 4.695 4.695 0 0 0-.74.248l-.829-.477-.995.57v.773l.34.196a.833.833 0 0 0-.144.448v.769c0 .319.23.626.707.899.417.245.889.381 1.373.396h.273a5.55 5.55 0 0 0 1.48-.318l.285-.1-.836.84v.77a4.077 4.077 0 0 0 3.208-.141l.821.477.992-.573v-.77l-.34-.2a.897.897 0 0 0 .166-.51Zm-2.094-.067a2.13 2.13 0 0 1-1.854.141c.777-.274 1.425-.514 1.98-.222l-.126.081Z"
        fill="#FFD04E"
      />
      <path
        d="M139.49 158.53c-.34.086-.666.197-.962.296a9.002 9.002 0 0 1-1.028.322 1.75 1.75 0 0 1-.489.045.988.988 0 0 1-.473-.141c-.318-.185-.37-.451.1-.758l.1-.063a2.15 2.15 0 0 1 .273-.133 1.878 1.878 0 0 1 1.443-.034l.833-.84a3.94 3.94 0 0 0-2.276-.081 4.73 4.73 0 0 0-.74.248l-.828-.477-.996.569.825.478c-.832.632-.851 1.291.089 1.831.418.243.89.379 1.373.396.091.006.182.006.274 0a5.445 5.445 0 0 0 1.48-.314c.951-.322 1.724-.696 2.364-.326.433.248.311.562-.159.832a2.134 2.134 0 0 1-1.883.115l-.874.873a4.065 4.065 0 0 0 3.208-.14l.822.477.991-.573-.821-.478c.829-.636.921-1.332-.041-1.898a3.34 3.34 0 0 0-2.605-.226Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M139.49 158.53c-.34.086-.666.197-.962.296a9.002 9.002 0 0 1-1.028.322 1.75 1.75 0 0 1-.489.045.988.988 0 0 1-.473-.141c-.318-.185-.37-.451.1-.758l.1-.063a2.15 2.15 0 0 1 .273-.133 1.878 1.878 0 0 1 1.443-.034l.833-.84a3.94 3.94 0 0 0-2.276-.081 4.73 4.73 0 0 0-.74.248l-.828-.477-.996.569.825.478c-.832.632-.851 1.291.089 1.831.418.243.89.379 1.373.396.091.006.182.006.274 0a5.445 5.445 0 0 0 1.48-.314c.951-.322 1.724-.696 2.364-.326.433.248.311.562-.159.832a2.134 2.134 0 0 1-1.883.115l-.874.873a4.065 4.065 0 0 0 3.208-.14l.822.477.991-.573-.821-.478c.829-.636.921-1.332-.041-1.898a3.34 3.34 0 0 0-2.605-.226Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m134.458 157.483 1.003-.451.821.359-.829-.477-.995.569Zm2.442-.311a4.655 4.655 0 0 1 2.135.074l-.577.818.833-.84a3.982 3.982 0 0 0-2.391-.052Zm5.18 1.591c.962.567.87 1.262.041 1.899.74-.796.599-1.351-.192-1.81a3.737 3.737 0 0 0-2.439-.333 3.333 3.333 0 0 1 2.59.244Zm.048 1.91.633.485-.803.562.992-.57-.822-.477Zm-1.672-.174a2.144 2.144 0 0 1-1.584.141l-.943.74.873-.874a2.137 2.137 0 0 0 1.654-.007Zm-2.96-1.351a1.278 1.278 0 0 1-1.188-.115c-.288-.244-.103-.51.326-.74-.466.308-.418.574-.1.759a.999.999 0 0 0 .473.141c.165.007.329-.008.489-.045Zm-2.223-1.18c-.071.059-.666.618-.404 1.173.263.555 1.158.977 1.85 1.055a2.935 2.935 0 0 1-1.372-.396c-.925-.54-.907-1.199-.074-1.832Z"
        fill="#F5F5F5"
      />
      <path
        d="M127.144 157.039a6.386 6.386 0 0 1 2.342-2.164c3.829-2.22 10.034-2.22 13.86 0a6.363 6.363 0 0 1 2.342 2.164h.529v2.006c-.07 1.391-1.021 2.771-2.864 3.833-3.825 2.22-10.034 2.22-13.86 0-1.85-1.062-2.801-2.442-2.871-3.833v-2.006h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M127.144 157.039a6.386 6.386 0 0 1 2.342-2.164c3.829-2.22 10.034-2.22 13.86 0a6.363 6.363 0 0 1 2.342 2.164h.529v2.006c-.07 1.391-1.021 2.771-2.864 3.833-3.825 2.22-10.034 2.22-13.86 0-1.85-1.062-2.801-2.442-2.871-3.833v-2.006h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M136.416 153.217c2.509 0 5.017.555 6.93 1.658a6.354 6.354 0 0 1 2.342 2.164h.529v2.006c-.07 1.391-1.021 2.771-2.863 3.833-1.913 1.11-4.422 1.658-6.931 1.658l-.007-11.319Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M141.77 154.139c.545.202 1.072.45 1.576.74a6.346 6.346 0 0 1 2.342 2.164h.529v2.006c-.07 1.391-1.021 2.771-2.864 3.833-.504.29-1.031.537-1.576.74l-.007-9.483Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M131.062 154.139c-.545.203-1.072.45-1.577.74a6.378 6.378 0 0 0-2.342 2.164h-.529v2.006c.071 1.391 1.033 2.771 2.871 3.833.505.289 1.032.537 1.577.74v-9.483Z"
        fill="#FFD04E"
      />
      <path
        d="M143.346 153.04c3.829 2.22 3.829 5.794 0 8.003-3.349 1.935-8.51 2.175-12.321.74l-.156-.06c-.477-.187-.939-.41-1.383-.666-3.194-1.85-3.723-4.639-1.591-6.8a7.386 7.386 0 0 1 1.587-1.203c3.829-2.223 10.038-2.223 13.864-.014Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M143.346 153.04c3.829 2.22 3.829 5.794 0 8.003-3.349 1.935-8.51 2.175-12.321.74l-.156-.06c-.477-.187-.939-.41-1.383-.666-3.194-1.85-3.723-4.639-1.591-6.8a7.386 7.386 0 0 1 1.587-1.203c3.829-2.223 10.038-2.223 13.864-.014Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M127.895 154.242a4.29 4.29 0 0 0-1.025 3.493c.34 1.942 3.063 3.582 3.999 3.974-.477-.188-.939-.41-1.383-.666-3.194-1.843-3.723-4.64-1.591-6.801Zm17.042 5.598a4.279 4.279 0 0 0 1.025-3.489c-.341-1.946-3.064-3.582-4-3.977.476.19.938.413 1.384.666 3.193 1.842 3.722 4.639 1.591 6.8Z"
        fill="#F5F5F5"
      />
      <path
        d="M136.419 162.297c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.262-9.109-5.262-9.109 2.356-9.109 5.262c0 2.906 4.078 5.261 9.109 5.261Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M136.419 162.297c5.031 0 9.109-2.355 9.109-5.261s-4.078-5.262-9.109-5.262-9.109 2.356-9.109 5.262c0 2.906 4.078 5.261 9.109 5.261Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M127.721 158.605c-.74-1.355-.492-2.846.718-4.111.238-.246.495-.473.769-.677a8.186 8.186 0 0 1 1.188-.729c-.37.621-.241 1.291 1.905 1.417 4.2.244-1.11 4.259-1.11 4.259s-2.719-1.306-3.47-.159Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M128.158 157.494c-.633-.07-.944-.717-.7-1.446s.955-1.262 1.584-1.192c.629.071.943.718.699 1.447-.244.729-.954 1.262-1.583 1.191Z"
        fill="#fff"
      />
      <path
        d="M134.799 160.839c.207-1.558 7.03-5.876 7.03-5.876s1.513-.606 1.01-1.665a7.256 7.256 0 0 1 1.184.822c2.027 1.757 2.031 4.07 0 5.827a7.086 7.086 0 0 1-.441.352 7.877 7.877 0 0 1-.677.436 6.197 6.197 0 0 1-.721.37c-.248.108-.404.182-.614.263a13.243 13.243 0 0 1-2.672.722l-.459.062c-1.502.195-3.025.17-4.521-.074 0 0 1.073-.214.881-1.239Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M134.799 160.839c.207-1.558 7.03-5.876 7.03-5.876s1.513-.606 1.01-1.665a7.256 7.256 0 0 1 1.184.822c2.027 1.757 2.031 4.07 0 5.827a7.086 7.086 0 0 1-.441.352 7.877 7.877 0 0 1-.677.436 6.197 6.197 0 0 1-.721.37c-.248.108-.404.182-.614.263a13.243 13.243 0 0 1-2.672.722l-.459.062c-1.502.195-3.025.17-4.521-.074 0 0 1.073-.214.881-1.239Z"
        fill="#fff"
      />
      <path
        d="M141.222 154.264c2.542 1.48 2.645 3.808.311 5.347-.1.067-.204.133-.311.192-2.653 1.532-6.949 1.532-9.598 0-2.649-1.532-2.653-4.011 0-5.55.107-.063.218-.126.333-.181 2.664-1.336 6.723-1.262 9.265.192Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M141.222 154.264c2.542 1.48 2.645 3.808.311 5.347-.1.067-.204.133-.311.192-2.653 1.532-6.949 1.532-9.598 0-2.649-1.532-2.653-4.011 0-5.55.107-.063.218-.126.333-.181 2.664-1.336 6.723-1.262 9.265.192Z"
        fill="#000"
      />
      <path
        d="M141.007 154.387c2.535 1.461 2.535 3.833 0 5.294-2.534 1.462-6.66 1.48-9.176 0s-2.534-3.833 0-5.294c2.535-1.462 6.642-1.466 9.176 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M141.007 154.387c2.535 1.461 2.535 3.833 0 5.294-2.534 1.462-6.66 1.48-9.176 0s-2.534-3.833 0-5.294c2.535-1.462 6.642-1.466 9.176 0Z"
        fill="#000"
      />
      <path
        d="M141.007 155.43c-2.534-1.462-6.66-1.462-9.176 0-1.036.599-1.646 1.346-1.85 2.127.189.777.8 1.528 1.85 2.124 2.535 1.48 6.642 1.48 9.176 0 1.036-.596 1.647-1.347 1.85-2.124-.203-.781-.814-1.528-1.85-2.127Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M141.007 155.43c-2.534-1.462-6.66-1.462-9.176 0-1.036.599-1.646 1.346-1.85 2.127.189.777.8 1.528 1.85 2.124 2.535 1.48 6.642 1.48 9.176 0 1.036-.596 1.647-1.347 1.85-2.124-.203-.781-.814-1.528-1.85-2.127Z"
        fill="#000"
      />
      <path
        d="M140.504 158.161v-.774c0-.318-.218-.625-.691-.902a3.324 3.324 0 0 0-2.59-.237c-.345.085-.666.196-.962.299a9.785 9.785 0 0 1-1.033.319c-.16.038-.324.054-.488.048a1.03 1.03 0 0 1-.407-.108l.033-.022a2.02 2.02 0 0 1 1.813-.233l.833-.836v-.773a3.987 3.987 0 0 0-2.272-.082 4.576 4.576 0 0 0-.74.252l-.833-.481-.991.573v.77l.34.196a.843.843 0 0 0-.148.448v.769c0 .319.226.626.707.903.416.243.887.378 1.369.392h.277a5.473 5.473 0 0 0 1.48-.318l.285-.1-.829.836v.77a4.064 4.064 0 0 0 3.208-.137l.822.474.991-.574v-.769l-.34-.196a.873.873 0 0 0 .166-.507Zm-2.09-.063c-.078.04-.155.081-.233.114a2.132 2.132 0 0 1-1.621.023c.777-.274 1.425-.515 1.98-.219l-.126.082Z"
        fill="#FFD04E"
      />
      <path
        d="M137.223 156.24a10.34 10.34 0 0 0-.962.3 9.78 9.78 0 0 1-1.033.318c-.16.038-.324.055-.488.048a1.082 1.082 0 0 1-.474-.14c-.318-.185-.37-.455.1-.759a2.028 2.028 0 0 1 1.795-.237l.832-.84a3.996 3.996 0 0 0-2.272-.081 4.61 4.61 0 0 0-.74.252l-.832-.481-.992.573.822.474c-.833.632-.851 1.291.088 1.85.417.243.887.378 1.369.392h.278a5.473 5.473 0 0 0 1.48-.318c.951-.318 1.724-.696 2.364-.326.429.252.311.563-.159.836-.078.041-.155.082-.233.115a2.136 2.136 0 0 1-1.654 0l-.855.884a4.08 4.08 0 0 0 3.208-.137l.822.474.991-.573-.817-.478c.825-.64.921-1.335-.045-1.902a3.324 3.324 0 0 0-2.593-.244Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M137.223 156.24a10.34 10.34 0 0 0-.962.3 9.78 9.78 0 0 1-1.033.318c-.16.038-.324.055-.488.048a1.082 1.082 0 0 1-.474-.14c-.318-.185-.37-.455.1-.759a2.028 2.028 0 0 1 1.795-.237l.832-.84a3.996 3.996 0 0 0-2.272-.081 4.61 4.61 0 0 0-.74.252l-.832-.481-.992.573.822.474c-.833.632-.851 1.291.088 1.85.417.243.887.378 1.369.392h.278a5.473 5.473 0 0 0 1.48-.318c.951-.318 1.724-.696 2.364-.326.429.252.311.563-.159.836-.078.041-.155.082-.233.115a2.136 2.136 0 0 1-1.654 0l-.855.884a4.08 4.08 0 0 0 3.208-.137l.822.474.991-.573-.817-.478c.825-.64.921-1.335-.045-1.902a3.324 3.324 0 0 0-2.593-.244Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m132.187 155.197 1.002-.456.822.363-.833-.481-.991.574Zm2.43-.311a4.588 4.588 0 0 1 2.135.07l-.573.814.828-.84a3.948 3.948 0 0 0-2.39-.044Zm5.18 1.591c.966.566.87 1.262.044 1.902.74-.8.6-1.355-.196-1.813a3.753 3.753 0 0 0-2.438-.333 3.316 3.316 0 0 1 2.59.244Zm.06 1.909.629.485-.799.562.991-.573-.821-.474Zm-1.676-.174a2.144 2.144 0 0 1-1.58.137l-.944.74.87-.873a2.116 2.116 0 0 0 1.654-.004Zm-2.957-1.354a1.297 1.297 0 0 1-1.187-.111c-.289-.248-.104-.511.325-.74-.466.303-.418.573-.1.758.145.083.307.131.474.141.164.006.329-.01.488-.048Zm-2.223-1.18c-.071.063-.666.618-.404 1.176.263.559 1.155.973 1.85 1.051a2.884 2.884 0 0 1-1.369-.392c-.928-.544-.91-1.203-.077-1.835Z"
        fill="#F5F5F5"
      />
      <path
        d="M129.223 153.857a6.29 6.29 0 0 1 2.342-2.164c3.826-2.22 10.031-2.22 13.86 0a6.322 6.322 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.025 2.771-2.863 3.837-3.83 2.22-10.035 2.22-13.861 0-1.85-1.066-2.801-2.446-2.871-3.837v-2.002h.522Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.25}
        d="M129.223 153.857a6.29 6.29 0 0 1 2.342-2.164c3.826-2.22 10.031-2.22 13.86 0a6.322 6.322 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.025 2.771-2.863 3.837-3.83 2.22-10.035 2.22-13.861 0-1.85-1.066-2.801-2.446-2.871-3.837v-2.002h.522Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M138.495 150.035c2.509 0 5.017.551 6.93 1.658a6.314 6.314 0 0 1 2.342 2.164h.529v2.002c-.07 1.391-1.024 2.771-2.863 3.837-1.913 1.11-4.44 1.657-6.93 1.654l-.008-11.315Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M143.849 150.96c.544.204 1.072.451 1.576.74a6.325 6.325 0 0 1 2.342 2.165h.529v2.002c-.07 1.391-1.025 2.771-2.864 3.837-.505.287-1.032.535-1.576.74l-.007-9.484Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M133.141 150.96c-.545.203-1.073.45-1.576.74a6.296 6.296 0 0 0-2.343 2.165h-.529v2.002c.071 1.391 1.029 2.771 2.872 3.837.504.288 1.031.536 1.576.74v-9.484Z"
        fill="#FFD04E"
      />
      <path
        d="M145.41 149.85c3.826 2.22 3.826 5.791 0 8-3.348 1.935-8.51 2.175-12.325.74l-.151-.06c-.478-.186-.94-.409-1.384-.666-3.193-1.85-3.722-4.639-1.591-6.796a7.474 7.474 0 0 1 1.591-1.199c3.841-2.239 10.045-2.239 13.86-.019Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M145.41 149.85c3.826 2.22 3.826 5.791 0 8-3.348 1.935-8.51 2.175-12.325.74l-.151-.06c-.478-.186-.94-.409-1.384-.666-3.193-1.85-3.722-4.639-1.591-6.796a7.474 7.474 0 0 1 1.591-1.199c3.841-2.239 10.045-2.239 13.86-.019Z"
        fill="#000"
      />
      <path
        opacity={0.5}
        d="M129.974 151.06a4.28 4.28 0 0 0-1.025 3.489c.337 1.946 3.06 3.582 4 3.974-.477-.187-.94-.409-1.384-.666-3.174-1.843-3.722-4.64-1.591-6.797Zm17.043 5.598a4.3 4.3 0 0 0 1.024-3.493c-.34-1.946-3.063-3.581-4.003-3.974.473.185.932.406 1.373.659 3.208 1.85 3.737 4.647 1.606 6.808Z"
        fill="#F5F5F5"
      />
      <path
        d="M144.94 157.568c3.559-2.053 3.559-5.383 0-7.437-3.559-2.053-9.328-2.057-12.887 0-3.559 2.058-3.556 5.384 0 7.437 3.556 2.054 9.328 2.054 12.887 0Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.4}
        d="M144.94 157.568c3.559-2.053 3.559-5.383 0-7.437-3.559-2.053-9.328-2.057-12.887 0-3.559 2.058-3.556 5.384 0 7.437 3.556 2.054 9.328 2.054 12.887 0Z"
        fill="#fff"
      />
      <path
        opacity={0.2}
        d="M147.194 155.422c.74-1.354.496-2.849-.714-4.114a5.835 5.835 0 0 0-.773-.674 7.107 7.107 0 0 0-.74-.488 8.7 8.7 0 0 0-.448-.244c.37.625.241 1.291-1.905 1.417-4.2.244 1.11 4.259 1.11 4.259s2.723-1.288 3.47-.156Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M146.761 154.313c.633-.074.944-.722.699-1.451-.244-.729-.954-1.262-1.583-1.191-.629.07-.944.718-.699 1.446.244.729.973 1.266 1.583 1.196Z"
        fill="#fff"
      />
      <path
        d="M140.119 157.654c-.207-1.558-7.03-5.876-7.03-5.876s-1.513-.607-1.01-1.661a7.053 7.053 0 0 0-1.184.821c-2.027 1.758-2.031 4.07 0 5.824a7.695 7.695 0 0 0 1.843 1.162 10.07 10.07 0 0 0 1.25.495 13.7 13.7 0 0 0 2.494.555 15.33 15.33 0 0 0 2.031.126 14.95 14.95 0 0 0 2.491-.203s-1.081-.215-.885-1.243Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M140.119 157.654c-.207-1.558-7.03-5.876-7.03-5.876s-1.513-.607-1.01-1.661a7.053 7.053 0 0 0-1.184.821c-2.027 1.758-2.031 4.07 0 5.824a7.695 7.695 0 0 0 1.843 1.162 10.07 10.07 0 0 0 1.25.495 13.7 13.7 0 0 0 2.494.555 15.33 15.33 0 0 0 2.031.126 14.95 14.95 0 0 0 2.491-.203s-1.081-.215-.885-1.243Z"
        fill="#fff"
      />
      <path
        d="M133.696 151.079c-2.546 1.48-2.646 3.811-.311 5.35l.311.192c2.649 1.528 6.948 1.528 9.598 0 2.649-1.528 2.652-4.01 0-5.55a7.506 7.506 0 0 0-.333-.181c-2.664-1.339-6.723-1.28-9.265.189Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.2}
        d="M133.696 151.079c-2.546 1.48-2.646 3.811-.311 5.35l.311.192c2.649 1.528 6.948 1.528 9.598 0 2.649-1.528 2.652-4.01 0-5.55a7.506 7.506 0 0 0-.333-.181c-2.664-1.339-6.723-1.28-9.265.189Z"
        fill="#000"
      />
      <path
        d="M138.499 157.594c3.584 0 6.489-1.676 6.489-3.744 0-2.068-2.905-3.745-6.489-3.745-3.585 0-6.49 1.677-6.49 3.745s2.905 3.744 6.49 3.744Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.5}
        d="M138.499 157.594c3.584 0 6.489-1.676 6.489-3.744 0-2.068-2.905-3.745-6.489-3.745-3.585 0-6.49 1.677-6.49 3.745s2.905 3.744 6.49 3.744Z"
        fill="#000"
      />
      <path
        d="M133.911 152.244c2.534-1.48 6.641-1.48 9.176 0 1.036.6 1.646 1.351 1.85 2.128-.189.777-.8 1.528-1.85 2.127-2.535 1.462-6.66 1.462-9.176 0-1.036-.599-1.651-1.35-1.85-2.127.199-.777.814-1.528 1.85-2.128Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.35}
        d="M133.911 152.244c2.534-1.48 6.641-1.48 9.176 0 1.036.6 1.646 1.351 1.85 2.128-.189.777-.8 1.528-1.85 2.127-2.535 1.462-6.66 1.462-9.176 0-1.036-.599-1.651-1.35-1.85-2.127.199-.777.814-1.528 1.85-2.128Z"
        fill="#000"
      />
      <path
        d="M142.584 154.979v-.774c0-.318-.219-.629-.692-.902a3.306 3.306 0 0 0-1.271-.382 3.31 3.31 0 0 0-1.319.145c-.341.085-.663.196-.959.296a9.251 9.251 0 0 1-1.032.318 1.809 1.809 0 0 1-.492.044.994.994 0 0 1-.403-.107l.029-.022.104-.063c.087-.05.177-.095.27-.133a1.85 1.85 0 0 1 1.443-.034l.833-.839v-.77a3.966 3.966 0 0 0-2.276-.085c-.246.065-.488.15-.721.251l-.833-.481-.992.574v.77l.341.196a.81.81 0 0 0-.148.451v.766c0 .318.229.625.707.903.418.242.889.378 1.372.396h.274a5.284 5.284 0 0 0 1.48-.319l.289-.096-.84.84v.77a4.077 4.077 0 0 0 3.208-.141l.821.474.995-.574v-.769l-.34-.196c.1-.15.153-.327.152-.507Zm-2.095-.067a2.148 2.148 0 0 1-1.853.141c.777-.278 1.428-.515 1.979-.222a.752.752 0 0 1-.126.081Z"
        fill="#FFD04E"
      />
      <path
        d="M139.302 153.054c-.341.086-.663.197-.959.296a9.05 9.05 0 0 1-1.032.319 1.809 1.809 0 0 1-.492.044 1.014 1.014 0 0 1-.47-.141c-.322-.185-.37-.455.096-.758l.104-.063c.089-.052.181-.096.27-.137a1.876 1.876 0 0 1 1.443-.029l.833-.84a3.966 3.966 0 0 0-2.276-.085 4.961 4.961 0 0 0-.721.251l-.833-.481-.992.574.822.477c-.836.636-.851 1.291.085 1.85a2.962 2.962 0 0 0 1.646.396 5.275 5.275 0 0 0 1.48-.318c.955-.319 1.725-.692 2.368-.322.43.248.311.558-.162.832a2.136 2.136 0 0 1-1.884.115l-.873.877a4.08 4.08 0 0 0 3.208-.141l.821.474.996-.574-.822-.473c.825-.64.922-1.336-.044-1.898a3.321 3.321 0 0 0-2.612-.245Z"
        fill="#FFD04E"
      />
      <path
        opacity={0.3}
        d="M139.302 153.054c-.341.086-.663.197-.959.296a9.05 9.05 0 0 1-1.032.319 1.809 1.809 0 0 1-.492.044 1.014 1.014 0 0 1-.47-.141c-.322-.185-.37-.455.096-.758l.104-.063c.089-.052.181-.096.27-.137a1.876 1.876 0 0 1 1.443-.029l.833-.84a3.966 3.966 0 0 0-2.276-.085 4.961 4.961 0 0 0-.721.251l-.833-.481-.992.574.822.477c-.836.636-.851 1.291.085 1.85a2.962 2.962 0 0 0 1.646.396 5.275 5.275 0 0 0 1.48-.318c.955-.319 1.725-.692 2.368-.322.43.248.311.558-.162.832a2.136 2.136 0 0 1-1.884.115l-.873.877a4.08 4.08 0 0 0 3.208-.141l.821.474.996-.574-.822-.473c.825-.64.922-1.336-.044-1.898a3.321 3.321 0 0 0-2.612-.245Z"
        fill="#fff"
      />
      <path
        opacity={0.45}
        d="m134.266 152.011 1.002-.451.822.359-.833-.481-.991.573Zm2.431-.311a4.696 4.696 0 0 1 2.135.07l-.577.822.832-.84a3.948 3.948 0 0 0-2.39-.052Zm5.18 1.591c.966.563.87 1.258.045 1.898.74-.795.599-1.354-.197-1.813a3.785 3.785 0 0 0-2.438-.333 3.332 3.332 0 0 1 2.59.248Zm.059 1.909.629.485-.803.562.995-.573-.821-.474Zm-1.676-.17a2.125 2.125 0 0 1-1.584.137l-.944.74.874-.877a2.132 2.132 0 0 0 1.654 0Zm-2.956-1.354a1.298 1.298 0 0 1-1.192-.115c-.285-.248-.1-.51.326-.74-.463.304-.418.574-.096.759.143.084.304.132.47.14.165.008.331-.007.492-.044Zm-2.224-1.184c-.071.063-.67.622-.404 1.177.267.555 1.155.977 1.85 1.051a2.958 2.958 0 0 1-1.372-.396c-.925-.541-.911-1.195-.074-1.832Z"
        fill="#F5F5F5"
      />
      <path
        d="m146.746 152.784.248-1.876.244 1.876 3.248.141-3.248.144-.244 1.876-.248-1.876-3.249-.144 3.249-.141Z"
        fill="#fff"
      />
      <path
        d="M129.041 55.64c6.312-.998 9.55-4.07 11.692-7.862 1.565-2.771 2.157-7.589 1.45-11.14a19.77 19.77 0 0 0-2.053-5.691c1.11-2.894.407-6.131-1.01-8.906-1.809-3.541-5.25-6.168-9.409-5.617-.674.09-.182.74.37.985 4.769 2.164 6.234 5.779 6.66 9.416a10.806 10.806 0 0 0-1.04-.74c-3.404-2.168-8.928-2.701-12.661-1.166-3.734 1.536-4.337 5.225-1.754 8.17 3.485 3.978 9.99 5.043 14.578 2.553.51 1.677.718 3.43.614 5.18-.203 3.297-1.928 6.235-5.117 8.166-1.08.655-3.522 1.199-4.784 1.11-2.176-.178-2.934-.289-4.869-1.11-.892-.37-1.78.322-2.072 1.17-1.743 5.076 6.008 6.023 9.405 5.483Zm5.025-23.716c-1.85.976-4.544 1.48-6.494.71-1.258-.485-2.22-.973-2.864-1.817-1.11-1.48.467-2.198 2.22-2.186 2.868.014 5.399 1.024 7.138 3.293Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="M140.13 30.947a19.386 19.386 0 0 1 1.721 4.296c-1.754 2.3-4.322 3.056-5.402 3.281a14.963 14.963 0 0 0-.57-2.897c2.745-1.587 3.485-3 4.251-4.68Zm-6.064.977a8.469 8.469 0 0 0-.692-.796 7.51 7.51 0 0 0 2.076-1.757c1.224-1.454 1.306-2.546 1.306-2.546.103 1.78-1.106 4.226-2.69 5.099Z"
        fill="#000"
      />
      <path
        d="M80.538 132.752v-.107l-.019-.115c-.37-2.516 1.11-5.117 4.44-7.081 6.031-3.571 15.877-3.678 21.986-.237 3.359 1.89 4.887 4.44 4.58 6.985v.115c0 .033 6.446-.906 6.446-.906l-1.48 1.579a28.704 28.704 0 0 0-7.374 15.296l-.818 5.465v.056c-.259 1.539-1.399 3.045-3.426 4.247-4.696 2.775-12.35 2.86-17.102.182-2.053-1.155-3.226-2.635-3.518-4.17v-.082l-3.715-21.227Z"
        fill="#EAB420"
      />
      <path
        opacity={0.1}
        d="M80.538 132.752v-.107l-.019-.115c-.37-2.516 1.11-5.117 4.44-7.081 6.031-3.571 15.877-3.678 21.986-.237 3.359 1.89 4.887 4.44 4.58 6.985v.115c0 .033 6.446-.906 6.446-.906l-1.48 1.579a28.704 28.704 0 0 0-7.374 15.296l-.818 5.465v.056c-.259 1.539-1.399 3.045-3.426 4.247-4.696 2.775-12.35 2.86-17.102.182-2.053-1.155-3.226-2.635-3.518-4.17v-.082l-3.715-21.227Z"
        fill="#C89917"
      />
      <path
        d="M112.85 113.627c0-.037 0-.074-.019-.107l-.022-.115c-.37-2.516 1.155-5.043 4.44-7.082 2.316-1.443 14.43-1.572 21.46-1.65 4.166-.044 6.453-.488 6.146 2.035v.115c0 .033 4.573-5.754 4.573-5.754a78.967 78.967 0 0 0-7.219 22.881l-1.609 10.671v.055c-.263 1.54-1.402 3.046-3.43 4.248-4.692 2.775-12.347 2.86-17.101.181-2.05-1.154-3.223-2.634-3.519-4.17v-.081l-3.7-21.227Z"
        fill="#E7B11F"
      />
      <path
        d="M76.797 120.642v-.107l.019-.115c.307-2.523-1.262-5.017-4.577-6.985-2.346-1.391-14.464-1.258-21.46-1.184-4.167.044-6.46-.352-6.102 2.168v.215l4.81 27.598v.055c.296 1.536 1.48 3.016 3.519 4.17 4.75 2.675 12.41 2.59 17.101-.185 2.028-1.198 3.168-2.704 3.43-4.244v-.081l3.26-21.305Z"
        fill="#EAB420"
      />
      <path
        d="M76.797 120.642v-.107l.019-.115c.307-2.523-1.262-5.017-4.577-6.985-2.346-1.391-14.464-1.258-21.46-1.184-4.167.044-6.46-.352-6.102 2.168v.215l4.81 27.598v.055c.296 1.536 1.48 3.016 3.519 4.17 4.75 2.675 12.41 2.59 17.101-.185 2.028-1.198 3.168-2.704 3.43-4.244v-.081l3.26-21.305Z"
        fill="#E7B11F"
      />
      <path
        d="M77.567 41.152c6.856-3.057 16.206-4.322 24.223-4.41a49.555 49.555 0 0 1 50.087 49.013c.196 18.208-9.32 35.287-22.773 45.651-6.471 4.984-15.977 10.119-21.904 12.528-10.105 4.099-16.473 4.54-25.623 4.64a49.56 49.56 0 0 1-35.193-14.134 49.567 49.567 0 0 1-14.89-34.88c-.137-12.562 4.525-23.736 11.973-32.679 3.082-3.7 8-9.375 11.892-12.25 7.593-5.602 14.593-10.083 22.208-13.48Z"
        fill="#EAB420"
      />
      <path
        opacity={0.3}
        d="M77.567 41.152c6.856-3.057 16.206-4.322 24.223-4.41a49.555 49.555 0 0 1 50.087 49.013c.196 18.208-9.32 35.287-22.773 45.651-6.471 4.984-15.977 10.119-21.904 12.528-10.105 4.099-16.473 4.54-25.623 4.64a49.56 49.56 0 0 1-35.193-14.134 49.567 49.567 0 0 1-14.89-34.88c-.137-12.562 4.525-23.736 11.973-32.679 3.082-3.7 8-9.375 11.892-12.25 7.593-5.602 14.593-10.083 22.208-13.48Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M81.807 128.061a9.054 9.054 0 1 0 0-18.108 9.054 9.054 0 0 0 0 18.108ZM37.818 96.315a9.053 9.053 0 0 0-5.095-8.14 48.347 48.347 0 0 0-1.229 11.388 49.61 49.61 0 0 0 .326 5.269 9.06 9.06 0 0 0 5.998-8.517Z"
        fill="#BC9118"
      />
      <path
        opacity={0.3}
        d="M121.653 121.427c18.947-15.67 30.069-50.017 14.537-71.31a49.427 49.427 0 0 1 15.688 35.638c.196 18.208-9.32 35.287-22.774 45.651-6.471 4.984-15.976 10.119-21.904 12.528-10.104 4.1-16.472 4.54-25.622 4.64a49.44 49.44 0 0 1-36.741-15.722 45.32 45.32 0 0 1-.474-.518c28.02 19.71 58.331 4.759 77.29-10.907Z"
        fill="#C09317"
      />
      <path
        d="m69.327 59.033-7.603 4.503c-7.674-2.127-16.81-.684-22.552 9.25 0 0-2.246-23.114.637-29.54l2.22-1.31c.962-.578 2.523-.763 4.391-.46 9.45 1.555 18.064 9.314 22.907 17.557Z"
        fill="#BC911B"
      />
      <path
        d="M61.724 63.536c-9.935-2.438-17.453.74-22.552 9.25 0 0-9.05-33.16 5.11-30.051 9.59 2.109 17.442 20.801 17.442 20.801Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="M61.724 63.536c-9.935-2.438-17.453.74-22.552 9.25 0 0-9.05-33.16 5.11-30.051 9.59 2.109 17.442 20.801 17.442 20.801Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M47.36 60.377c9.173-3.478 14.382 3.16 14.382 3.16-9.934-2.439-17.453.74-22.551 9.25-.019.003-1.021-8.932 8.17-12.41Z"
        fill="#EAB420"
      />
      <path
        d="M77.123 72.206c8.466 7.537 16.099 17.134 21.77 31.572l7.297-4.281c2.72-2.816 9.62-26.603-4.27-35.29-9.287-5.802-24.797 7.999-24.797 7.999Z"
        fill="#BC911B"
      />
      <path
        d="M77.123 72.206c9.99 8.79 17.05 19.447 21.77 31.572 0 0 15.104-26.807 1.111-38.447-8.173-6.797-22.881 6.875-22.881 6.875Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="M77.123 72.206c9.99 8.79 17.05 19.447 21.77 31.572 0 0 15.104-26.807 1.111-38.447-8.173-6.797-22.881 6.875-22.881 6.875Z"
        fill="#fff"
      />
      <path
        opacity={0.5}
        d="M77.123 72.206s8.421-.093 15.788 9.768c6.886 9.224 5.983 21.804 5.983 21.804-4.721-12.125-11.766-22.781-21.771-31.572Z"
        fill="#EAB420"
      />
      <path
        d="M40.7 97.491c2.96-1.739 7.152-1.48 11.84 1.151 9.039 5.088 16.446 17.12 16.554 26.881.048 4.658-1.576 7.951-4.27 9.571-1.299.781-6.39 3.8-7.703 4.563-2.96 1.709-7.134 1.45-11.8-1.177-9.039-5.088-16.461-17.12-16.557-26.881-.048-4.669 1.576-7.947 4.262-9.568 1.302-.784 6.375-3.777 7.674-4.54Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="M33.026 102.031c1.302-.784 6.375-3.777 7.666-4.54 2.96-1.739 7.153-1.48 11.84 1.151 3.767 2.12 7.249 5.45 10.039 9.317L32.93 125.5c-2.546-4.51-4.118-9.449-4.166-13.901-.048-4.669 1.576-7.947 4.262-9.568Z"
        fill="#fff"
      />
      <path
        opacity={0.1}
        d="m67.34 116.783-28.394 16.724a38.286 38.286 0 0 1-6.016-8.007l29.64-17.542a37.618 37.618 0 0 1 4.77 8.825Z"
        fill="#fff"
      />
      <path
        d="M44.933 103.141c-9.035-5.087-16.28-1.302-16.169 8.459.111 9.76 7.518 21.793 16.554 26.88 9.035 5.088 16.28 1.299 16.169-8.458-.111-9.757-7.515-21.793-16.554-26.881Z"
        fill="#EAB420"
      />
      <path
        d="M44.933 103.141c-9.035-5.087-16.28-1.302-16.169 8.459.111 9.76 7.518 21.793 16.554 26.88 9.035 5.088 16.28 1.299 16.169-8.458-.111-9.757-7.515-21.793-16.554-26.881Z"
        fill="#EAB420"
      />
      <path
        opacity={0.3}
        d="M44.933 103.141c-9.035-5.087-16.28-1.302-16.169 8.459.111 9.76 7.518 21.793 16.554 26.88 9.035 5.088 16.28 1.299 16.169-8.458-.111-9.757-7.515-21.793-16.554-26.881Z"
        fill="#fff"
      />
      <path
        d="M50.96 130.425c1.11.622 1.983-.059 1.968-1.521l-.081-7.444c0-1.462-.921-3.149-2.024-3.771-1.11-.617-1.983.063-1.968 1.521l.081 7.448c.015 1.458.921 3.145 2.024 3.767Z"
        fill="#EAB420"
      />
      <path
        d="m52.847 121.46.081 7.445a2.74 2.74 0 0 1-.122.865 1.822 1.822 0 0 1-.436-.181c-1.11-.622-2.01-2.305-2.024-3.767l-.082-7.444a2.747 2.747 0 0 1 .122-.866c.152.042.299.102.437.178 1.102.621 2.009 2.309 2.024 3.77Z"
        fill="#EAB420"
      />
      <path
        opacity={0.15}
        d="m52.847 121.46.081 7.445a2.74 2.74 0 0 1-.122.865 1.822 1.822 0 0 1-.436-.181c-1.11-.622-2.01-2.305-2.024-3.767l-.082-7.444a2.747 2.747 0 0 1 .122-.866c.152.042.299.102.437.178 1.102.621 2.009 2.309 2.024 3.77Z"
        fill="#000"
      />
      <path
        d="M39.427 123.928c1.11.621 1.983-.06 1.968-1.521l-.08-7.444c0-1.462-.922-3.145-2.025-3.767-1.11-.622-1.983.059-1.965 1.521l.078 7.444c.019 1.462.925 3.149 2.024 3.767Z"
        fill="#EAB420"
      />
      <path
        d="m41.314 114.963.082 7.444c.007.293-.034.586-.122.866a1.885 1.885 0 0 1-.433-.178c-1.11-.621-2.01-2.309-2.024-3.77l-.082-7.444a2.656 2.656 0 0 1 .115-.881c.152.041.297.102.433.181 1.11.637 2.017 2.32 2.031 3.782Z"
        fill="#EAB420"
      />
      <path
        opacity={0.15}
        d="m41.314 114.963.082 7.444c.007.293-.034.586-.122.866a1.885 1.885 0 0 1-.433-.178c-1.11-.621-2.01-2.309-2.024-3.77l-.082-7.444a2.656 2.656 0 0 1 .115-.881c.152.041.297.102.433.181 1.11.637 2.017 2.32 2.031 3.782Z"
        fill="#000"
      />
      <path
        opacity={0.3}
        d="M58.297 137.055c4.048-5.698 1.277-17.515-3.36-24.645 3.926 5.42 6.487 11.903 6.55 17.612.103 9.757-7.134 13.545-16.17 8.458a30.873 30.873 0 0 1-8.14-6.904c5.743 6.719 16.799 11.566 21.12 5.479Z"
        fill="#fff"
      />
      <path
        d="M69.523 99.93c-.543 2.042 1.654.44 3.7.98 2.046.541 3.156 3.027 3.7.985a3.828 3.828 0 1 0-7.4-1.965ZM41.81 85.84c-1.236 1.713 1.388 1.003 3.1 2.242 1.714 1.24 1.85 3.952 3.105 2.22a3.826 3.826 0 0 0-6.205-4.462Z"
        fill="#263238"
      />
      <path
        d="M82.566 59.955 99.67 49.828l-3.848-2.168-17.11 10.127 3.853 2.168Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="M82.566 59.955 99.67 49.828l-3.848-2.168-17.11 10.127 3.853 2.168Z"
        fill="#000"
      />
      <path
        d="m95.823 47.66.022 2.209-15.203 9.002-1.928-1.084L95.823 47.66Z"
        fill="#EAB420"
      />
      <path
        opacity={0.2}
        d="m95.822 47.66.022 2.209 1.928 1.087 1.898-1.128-3.848-2.168Z"
        fill="#000"
      />
      <path
        d="m96.737 21.796-.326 12.984-14.914-.163-.463-4.355 15.703-8.466Z"
        fill="#96FFAD"
      />
      <path
        d="m81.497 34.617-.466-4.355s8.62-.155 14.43-6.253c3.41-3.593-.393-4.573-6.157-3.041-5.765 1.532-16.713 6.36-16.162 10.027.614 4.155 8.355 3.622 8.355 3.622Z"
        fill="#70D085"
      />
      <path
        d="m82.566 59.94-2.057-1.158-7.378-27.787c.207 1.295 4.44 2.93 8.773 2.756 11.903-.473 19.78-11.181 19.78-11.181L98.79 50.342 82.566 59.94Z"
        fill="#96FFAD"
      />
      <path
        d="M77.438 47.227c3.444 1.11 7.177.236 10.334 3.115a6.72 6.72 0 0 1 2.253 5.199l-7.46 4.399-2.056-1.158-3.072-11.555Z"
        fill="#70D085"
      />
      <path
        d="M81.485 37.21c-.877.041-4.44.212-7.218-1.946l.307 1.17c3.026 1.85 6.008 1.568 6.94 1.524 6.975-.277 12.622-3.656 16.314-6.66l-2.183 20.927.8-.473 2.32-22.23-.715.603c-3.57 3.075-9.342 6.8-16.565 7.086Z"
        fill="#37474F"
      />
      <path
        d="M73.13 30.995c.106.328.322.61.611.795.275.204.569.381.877.53.62.29 1.263.526 1.924.702 1.32.358 2.677.56 4.044.603 2.735.03 5.45-.456 8.004-1.435a28.522 28.522 0 0 0 7.13-3.981 34.001 34.001 0 0 0 3.14-2.642 32.204 32.204 0 0 0 2.824-2.997 30.837 30.837 0 0 1-5.78 5.88 27.357 27.357 0 0 1-7.189 4.07 20.93 20.93 0 0 1-8.14 1.346 16.757 16.757 0 0 1-4.07-.707 11.155 11.155 0 0 1-1.916-.773 5.151 5.151 0 0 1-.877-.566 1.52 1.52 0 0 1-.581-.825Z"
        fill="#263238"
      />
      <path
        d="M93.307 37.966a1.48 1.48 0 0 1 .644-.056.97.97 0 0 1 .455.2.896.896 0 0 1 .263.37c.058.143.088.297.089.451a.37.37 0 0 1-.067.222.395.395 0 0 1-.152.152l-.536.274a.241.241 0 0 1-.193.037.299.299 0 0 1-.11-.115.522.522 0 0 0-.326-.255c-.241-.02-.483.04-.685.174-.131.07-.255.153-.37.248a2.037 2.037 0 0 0-.322.322 1.618 1.618 0 0 0-.225.37 1.083 1.083 0 0 0-.093.37.503.503 0 0 0 .067.329.32.32 0 0 0 .259.107c.16.003.318-.014.473-.052l.703-.159c.25-.064.505-.096.763-.096a.88.88 0 0 1 .5.152c.134.1.228.246.262.41.052.223.07.453.052.681a2.804 2.804 0 0 1-.152.78 3.51 3.51 0 0 1-.37.778c-.16.258-.346.498-.555.718a4.48 4.48 0 0 1-.74.614l-.033.673a.518.518 0 0 1-.07.222.37.37 0 0 1-.152.152l-.618.318a.122.122 0 0 1-.145 0 .188.188 0 0 1-.051-.159l.037-.673c-.206.067-.42.1-.637.096-.178 0-.354-.044-.51-.13a.858.858 0 0 1-.333-.37 1.317 1.317 0 0 1-.119-.614.37.37 0 0 1 .067-.222.422.422 0 0 1 .151-.151l.537-.274a.256.256 0 0 1 .196-.041.192.192 0 0 1 .107.118.963.963 0 0 0 .119.193.347.347 0 0 0 .192.122.768.768 0 0 0 .318 0c.17-.038.333-.1.485-.185a3.47 3.47 0 0 0 .444-.27c.135-.1.259-.215.37-.34.106-.12.198-.252.274-.393.07-.134.11-.282.118-.433a.37.37 0 0 0-.088-.303.433.433 0 0 0-.315-.07 3.275 3.275 0 0 0-.53.085c-.21.051-.458.103-.74.155a2.723 2.723 0 0 1-.624.052.74.74 0 0 1-.452-.16.766.766 0 0 1-.251-.417 2.33 2.33 0 0 1-.052-.722c.013-.263.063-.523.148-.773a4.19 4.19 0 0 1 .858-1.425c.191-.21.403-.401.633-.57l.033-.676a.473.473 0 0 1 .07-.219.37.37 0 0 1 .152-.155l.618-.315a.122.122 0 0 1 .144 0 .185.185 0 0 1 .052.156l-.037.692Z"
        fill="#37474F"
      />
      <path
        d="M68.28 28.974a.662.662 0 0 1-.833.437l-6.146-1.905a.666.666 0 1 1 .396-1.273l6.142 1.909a.666.666 0 0 1 .44.832Zm-1.062 6.868a.66.66 0 0 1-.522.418l-6.363.95a.666.666 0 0 1-.197-1.316l6.364-.947a.666.666 0 0 1 .718.899v-.004Zm9.406-16.136a.665.665 0 0 1-1.284.07l-2.01-6.112a.666.666 0 0 1 1.266-.414l1.994 6.112c.042.11.054.229.034.344Zm-4.966 3.234a.663.663 0 0 1-1.091.37l-4.81-4.277a.666.666 0 0 1 .884-.996l4.81 4.277a.659.659 0 0 1 .207.626Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};
export default SvgNotificationBonuses;
